import { HashLink as Link } from 'react-router-hash-link';
import PinExtension from "../en/PinExtension.js";
import SupportUS from "../en/SupportUs.js";
import Header from '../Header.js';
import { useEffect } from 'react';
import { useHash } from '../UseHash';
import { scrollToSection } from '../Utils';
import { useParams } from "react-router-dom";

import Lang from '../Lang';
import '../en/Image Downloader/styles.css';

export default function ImageDownloaderGeneral(props){
    
const general = {
  "en": ["Pin extension icon"],
  "de": ["Erweiterungssymbol anheften"],
  "es": ["Fijar el ícono de la extensión"],
  "he": ["הצמדת סמל ההרחבה"],
  "it": ["Fissa l'icona dell'estensione"],
  "pt": ["Fixar ícone da extensão"],
  "hu": ["Bővítmény ikon rögzítése"],
  "tr": ["Uzantı simgesini sabitle"],
  "ru": ["Закрепить значок расширения"],
  "fr": ["Épingler l’icône de l’extension"],
  "vi": ["Ghim biểu tượng tiện ích"],
  "ko": ["확장 프로그램 아이콘 고정"],
  "ja": ["拡張機能のアイコンを固定"],
  "zh_CN": ["固定扩展图标"],
  "zh_TW": ["固定擴充功能圖示"],
  "th": ["ปักหมุดไอคอนส่วนขยาย"]
};
    const description = {
          "en": [
            "Quickly find and download images from web pages in bulk",
            "You can filter the images based on image characteristics.",
            "You can select which image to download or download all images that pass filtering.",
            "You can choose a custom folder for the images and a custom file name sequence.",
            "Main features:",
            "Very quick and clean group display of all images.",
            "Download a single, multiple or all images in the web page.",
            "Filter images by: width, height, type, orientation and aspect ratio or URL.",
            "Custom or auto generated folder and file names.",
            "Auto convert files to JPEG, PNG or WebP.",
            "Side panel support.",
            "Available for: "
          ],
          "de": [
            "Schnell Bilder von Webseiten in großen Mengen finden und herunterladen",
            "Sie können die Bilder nach Bildmerkmalen filtern.",
            "Sie können auswählen, welches Bild Sie herunterladen möchten oder alle Bilder, die den Filter bestehen, herunterladen.",
            "Sie können einen benutzerdefinierten Ordner für die Bilder und eine benutzerdefinierte Dateinamen-Sequenz wählen.",
            "Hauptfunktionen:",
            "Sehr schnelle und saubere Gruppenanzeige aller Bilder.",
            "Laden Sie ein einzelnes, mehrere oder alle Bilder auf der Webseite herunter.",
            "Filtern Sie Bilder nach: Breite, Höhe, Typ, Ausrichtung und Seitenverhältnis oder URL.",
            "Benutzerdefinierte oder automatisch generierte Ordner- und Dateinamen.",
            "Automatische Konvertierung von Dateien in JPEG, PNG oder WebP.",
            "Seitenleistenunterstützung.",
            "Verfügbar für: "
          ],
          "es": [
            "Encuentra y descarga rápidamente imágenes de páginas web en masa",
            "Puedes filtrar las imágenes según las características de la imagen.",
            "Puedes seleccionar qué imagen descargar o descargar todas las imágenes que pasen el filtro.",
            "Puedes elegir una carpeta personalizada para las imágenes y una secuencia de nombres de archivo personalizada.",
            "Características principales:",
            "Visualización rápida y limpia de todas las imágenes.",
            "Descarga una sola, varias o todas las imágenes de la página web.",
            "Filtra las imágenes por: ancho, alto, tipo, orientación y relación de aspecto o URL.",
            "Nombres de carpetas y archivos personalizados o generados automáticamente.",
            "Convierte automáticamente los archivos a JPEG, PNG o WebP.",
            "Soporte de panel lateral.",
            "Disponible para: "
          ],
          "he": [
            "מצא והורד תמונות מעמודי אינטרנט בכמויות גדולות",
            "תוכל לסנן את התמונות על פי מאפיינים של תמונה.",
            "תוכל לבחור איזו תמונה להוריד או להוריד את כל התמונות שעוברות את הסינון.",
            "תוכל לבחור תיקיה מותאמת אישית לתמונות ורצף שמות קבצים מותאם אישית.",
            "תכונות עיקריות:",
            "תצוגה מהירה ונקייה של כל התמונות.",
            "הורד תמונה בודדת, מספר תמונות או את כל התמונות בדף האינטרנט.",
            "סנן תמונות לפי: רוחב, גובה, סוג, אוריינטציה ויחס גובה-רוחב או כתובת URL.",
            "שמות תיקיות וקבצים מותאמים אישית או שנוצרים אוטומטית.",
            "המרת קבצים אוטומטית ל-JPEG, PNG או WebP.",
            "תמיכה בפנל צד.",
            "זמין ל:"
          ],
          "hu": [
            "Gyorsan találjon és töltsön le képeket weboldalakról tömegesen",
            "A képeket a képi jellemzők alapján szűrheti.",
            "Kiválaszthatja, melyik képet szeretné letölteni, vagy letöltheti az összes képet, amely megfelel a szűrésnek.",
            "Testreszabott mappát és fájlnevet is választhat a képekhez.",
            "Főbb jellemzők:",
            "Nagyon gyors és tiszta csoportos megjelenítés minden képről.",
            "Letölthet egyetlen, több vagy az összes képet a weboldalon.",
            "Szűrje a képeket: szélesség, magasság, típus, tájolás és képarány vagy URL szerint.",
            "Egyéni vagy automatikusan generált mappák és fájlnevek.",
            "Automatikus fájlátalakítás JPEG, PNG vagy WebP formátumra.",
            "Oldalsáv támogatás.",
            "Elérhető: "
          ],
          "fr": [
            "Trouvez et téléchargez rapidement des images depuis des pages web en masse",
            "Vous pouvez filtrer les images en fonction de leurs caractéristiques.",
            "Vous pouvez choisir quelle image télécharger ou télécharger toutes les images qui passent le filtrage.",
            "Vous pouvez choisir un dossier personnalisé pour les images et une séquence de noms de fichiers personnalisée.",
            "Principales fonctionnalités :",
            "Affichage rapide et propre de toutes les images.",
            "Téléchargez une image unique, plusieurs images ou toutes les images de la page web.",
            "Filtrer les images par : largeur, hauteur, type, orientation et ratio ou URL.",
            "Noms de dossiers et de fichiers personnalisés ou générés automatiquement.",
            "Conversion automatique des fichiers en JPEG, PNG ou WebP.",
            "Prise en charge du panneau latéral.",
            "Disponible pour : "
          ],
          "it": [
            "Trova e scarica rapidamente immagini da pagine web in blocco",
            "Puoi filtrare le immagini in base alle caratteristiche dell'immagine.",
            "Puoi selezionare quale immagine scaricare o scaricare tutte le immagini che passano il filtro.",
            "Puoi scegliere una cartella personalizzata per le immagini e una sequenza di nomi file personalizzata.",
            "Caratteristiche principali:",
            "Visualizzazione molto veloce e pulita di tutte le immagini.",
            "Scarica una singola, più o tutte le immagini dalla pagina web.",
            "Filtra le immagini per: larghezza, altezza, tipo, orientamento e rapporto di aspetto o URL.",
            "Nomi cartelle e file personalizzati o generati automaticamente.",
            "Converti automaticamente i file in JPEG, PNG o WebP.",
            "Supporto pannello laterale.",
            "Disponibile per: "
          ],
          "ja": [
            "ウェブページから画像を一括で素早く見つけてダウンロード",
            "画像の特徴に基づいて画像をフィルタリングできます。",
            "ダウンロードする画像を選択するか、フィルタリングを通過したすべての画像をダウンロードできます。",
            "画像用のカスタムフォルダーとカスタムファイル名シーケンスを選択できます。",
            "主な機能：",
            "すべての画像の非常に迅速でクリーンなグループ表示。",
            "ウェブページから単一の画像、複数の画像、またはすべての画像をダウンロード。",
            "画像を次の条件でフィルタリング：幅、高さ、タイプ、方向、アスペクト比、またはURL。",
            "カスタムまたは自動生成されたフォルダーとファイル名。",
            "JPEG、PNG、またはWebPに自動変換。",
            "サイドパネルのサポート。",
            "利用可能なもの："
          ],
          "ko": [
            "웹 페이지에서 이미지를 대량으로 빠르게 찾고 다운로드",
            "이미지 특성에 따라 이미지를 필터링할 수 있습니다.",
            "다운로드할 이미지를 선택하거나 필터링을 통과한 모든 이미지를 다운로드할 수 있습니다.",
            "이미지에 대해 사용자 지정 폴더와 사용자 지정 파일 이름 시퀀스를 선택할 수 있습니다.",
            "주요 기능:",
            "모든 이미지에 대해 매우 빠르고 깔끔한 그룹 표시.",
            "웹 페이지에서 단일 이미지, 여러 이미지 또는 모든 이미지를 다운로드.",
            "다음 기준에 따라 이미지 필터링: 너비, 높이, 유형, 방향 및 가로세로 비율 또는 URL.",
            "사용자 지정 또는 자동 생성된 폴더 및 파일 이름.",
            "파일을 JPEG, PNG 또는 WebP로 자동 변환.",
            "사이드 패널 지원.",
            "사용 가능:"
          ],
          "ru": [
            "Быстро находите и загружайте изображения с веб-страниц оптом",
            "Вы можете фильтровать изображения по характеристикам изображения.",
            "Вы можете выбрать, какое изображение скачать, или скачать все изображения, которые проходят фильтрацию.",
            "Вы можете выбрать настраиваемую папку для изображений и последовательность настраиваемых имен файлов.",
            "Основные функции:",
            "Очень быстрый и чистый групповой вывод всех изображений.",
            "Скачайте одно, несколько или все изображения с веб-страницы.",
            "Фильтруйте изображения по: ширине, высоте, типу, ориентации, соотношению сторон или URL.",
            "Пользовательские или автоматически генерируемые папки и имена файлов.",
            "Автоматическое преобразование файлов в JPEG, PNG или WebP.",
            "Поддержка боковой панели.",
            "Доступно для:"
          ],
          "pt": [
            "Encontre e baixe rapidamente imagens de páginas web em massa",
            "Você pode filtrar as imagens com base em características da imagem.",
            "Você pode selecionar qual imagem baixar ou baixar todas as imagens que passam pelo filtro.",
            "Você pode escolher uma pasta personalizada para as imagens e uma sequência personalizada de nomes de arquivos.",
            "Principais características:",
            "Exibição muito rápida e limpa de todas as imagens.",
            "Baixe uma única, várias ou todas as imagens da página da web.",
            "Filtre as imagens por: largura, altura, tipo, orientação e proporção ou URL.",
            "Nomes de pastas e arquivos personalizados ou gerados automaticamente.",
            "Conversão automática de arquivos para JPEG, PNG ou WebP.",
            "Suporte a painel lateral.",
            "Disponível para:"
          ],
          "th": [
            "ค้นหาและดาวน์โหลดภาพจากหน้าเว็บเป็นจำนวนมากได้อย่างรวดเร็ว",
            "คุณสามารถกรองภาพตามลักษณะของภาพได้",
            "คุณสามารถเลือกภาพที่ต้องการดาวน์โหลดหรืดาวน์โหลดภาพทั้งหมดที่ผ่านการกรอง",
            "คุณสามารถเลือกโฟลเดอร์ที่กำหนดเองสำหรับภาพและลำดับชื่อไฟล์ที่กำหนดเองได้",
            "คุณสมบัติหลัก:",
            "แสดงผลภาพทั้งหมดอย่างรวดเร็วและสะอาดตา",
            "ดาวน์โหลดภาพเดี่ยว, หลายภาพ หรือทั้งหมดจากหน้าเว็บ",
            "กรองภาพตาม: ความกว้าง, ความสูง, ประเภท, ทิศทาง และอัตราส่วน หรือ URL",
            "ชื่อโฟลเดอร์และไฟล์ที่กำหนดเองหรือสร้างขึ้นโดยอัตโนมัติ",
            "แปลงไฟล์อัตโนมัติเป็น JPEG, PNG หรือ WebP",
            "รองรับแผงด้านข้าง",
            "สามารถใช้ได้กับ:"
          ],
          "tr": [
            "Web sayfalarından toplu olarak hızlıca resimler bulun ve indirin",
            "Resimleri, görüntü özelliklerine göre filtreleyebilirsiniz.",
            "İndirilecek resmi seçebilir veya filtrelemeyi geçen tüm resimleri indirebilirsiniz.",
            "Resimler için özel bir klasör ve özel bir dosya adı sırası seçebilirsiniz.",
            "Ana özellikler:",
            "Tüm resimlerin çok hızlı ve temiz grup görüntüsü.",
            "Web sayfasından tek bir, birden fazla veya tüm resimleri indirin.",
            "Resimleri şu şekilde filtreleyin: genişlik, yükseklik, tür, yönelim ve en-boy oranı veya URL.",
            "Özel veya otomatik oluşturulmuş klasör ve dosya adları.",
            "JPEG, PNG veya WebP'ye otomatik dönüştürme.",
            "Yan panel desteği.",
            "Mevcut: "
          ],
          "vi": [
            "Tìm và tải xuống hình ảnh từ các trang web nhanh chóng và hàng loạt",
            "Bạn có thể lọc các hình ảnh dựa trên các đặc điểm hình ảnh.",
            "Bạn có thể chọn hình ảnh để tải xuống hoặc tải tất cả các hình ảnh vượt qua bộ lọc.",
            "Bạn có thể chọn thư mục tùy chỉnh cho các hình ảnh và một chuỗi tên tệp tùy chỉnh.",
            "Các tính năng chính:",
            "Hiển thị nhóm tất cả các hình ảnh nhanh chóng và sạch sẽ.",
            "Tải xuống một, nhiều hoặc tất cả các hình ảnh từ trang web.",
            "Lọc các hình ảnh theo: chiều rộng, chiều cao, loại, hướng và tỷ lệ khung hình hoặc URL.",
            "Tên thư mục và tệp tùy chỉnh hoặc tự động tạo.",
            "Chuyển đổi tệp tự động thành JPEG, PNG hoặc WebP.",
            "Hỗ trợ bảng điều khiển bên.",
            "Có sẵn cho:"
          ],
          "zh_CN": [
            "快速查找并批量下载网页中的图像",
            "您可以根据图像特征过滤图像。",
            "您可以选择下载哪些图像或下载所有通过过滤的图像。",
            "您可以为图像选择自定义文件夹和自定义文件名序列。",
            "主要功能：",
            "非常快速和清晰的所有图像分组显示。",
            "从网页中下载单个图像、多个图像或所有图像。",
            "按以下条件过滤图像：宽度、高度、类型、方向和宽高比或URL。",
            "自定义或自动生成的文件夹和文件名。",
            "自动将文件转换为JPEG、PNG或WebP。",
            "支持侧边面板。",
            "适用于："
          ],
          "zh_TW": [
            "快速從網頁批量查找和下載圖像",
            "您可以根據圖像特徵過濾圖像。",
            "您可以選擇下載哪些圖像或下載所有通過過濾的圖像。",
            "您可以為圖像選擇自定義文件夾和自定義文件名序列。",
            "主要特點：",
            "非常快速和清晰的所有圖像分組顯示。",
            "從網頁下載單個圖像、複數圖像或所有圖像。",
            "按以下條件過濾圖像：寬度、高度、類型、方向和寬高比或URL。",
            "自定義或自動生成的文件夾和文件名。",
            "自動將文件轉換為JPEG、PNG或WebP。",
            "支持側邊面板。",
            "適用於："
          ]
        };
    const limition = {
  "en": [
    "Limitations",
    "(All) extensions do not work on add-on download sites such as the Chrome Web Store and non-URL sites such as the first page when you open a new tab.",
    "Usually, only images that are loaded prior to using the extension can be detected.",
    "If a site uses a thumbnail, you are most likely not able to capture the larger image.",
    "Some sites employ special techniques that prevent the detection and download of images.",
    "Before using the Image Downloader extension, follow the instructions below to ensure that the browser settings won't interfere."
  ],
  "de": [
    "Einschränkungen",
    "(Alle) Erweiterungen funktionieren nicht auf Download-Websites für Add-ons wie der Chrome Web Store und nicht-URL-Seiten wie der ersten Seite, wenn Sie einen neuen Tab öffnen.",
    "In der Regel können nur Bilder erkannt werden, die vor der Nutzung der Erweiterung geladen wurden.",
    "Wenn eine Seite ein Thumbnail verwendet, können Sie höchstwahrscheinlich das größere Bild nicht erfassen.",
    "Einige Seiten verwenden spezielle Techniken, die das Erkennen und Herunterladen von Bildern verhindern.",
    "Bevor Sie die 'Bild Downloader'-Erweiterung verwenden, folgen Sie den untenstehenden Anweisungen, um sicherzustellen, dass die Browsereinstellungen nicht stören."
  ],
  "es": [
    "Limitaciones",
    "(Todas) las extensiones no funcionan en sitios de descarga de complementos como la Chrome Web Store y sitios no-URL como la primera página cuando abres una nueva pestaña.",
    "Por lo general, solo las imágenes cargadas antes de usar la extensión pueden ser detectadas.",
    "Si un sitio usa una miniatura, lo más probable es que no puedas capturar la imagen más grande.",
    "Algunos sitios emplean técnicas especiales que evitan la detección y descarga de imágenes.",
    "Antes de usar la extensión 'Descargador de Imágenes', sigue las instrucciones a continuación para asegurarte de que la configuración del navegador no interfiera."
  ],
  "he": [
    "מגבלות",
    "(כל) ההרחבות לא פועלות באתרים להורדת תוספים כמו ה-Chrome Web Store ובאתרים שאינם כתובת URL, כגון הדף הראשון כאשר פותחים כרטיסייה חדשה.",
    "בדרך כלל, רק תמונות שהועמסו לפני השימוש בהרחבה ניתנות לזיהוי.",
    "אם אתר משתמש בתמונה ממוזערת, סביר להניח שלא תוכל ללכוד את התמונה הגדולה.",
    "חלק מהאתרים משתמשים בטכניקות מיוחדות שמונעות את זיהוי והורדת התמונות.",
    "לפני השימוש בהרחבת 'הורדת תמונות', עקוב אחרי ההוראות למטה על מנת לוודא שהגדרות הדפדפן לא יתערבו."
  ],
  "hu": [
    "Korlátozások",
    "(Minden) kiterjesztés nem működik az olyan bővítmény letöltő oldalakon, mint a Chrome Web Áruház és a nem-URL oldalak, mint az első oldal, amikor új lapot nyitsz.",
    "Általában csak azok a képek észlelhetők, amelyek a kiterjesztés használata előtt töltődtek be.",
    "Ha egy oldal miniatűr képet használ, valószínűleg nem fogod tudni rögzíteni a nagyobb képet.",
    "Néhány oldal speciális technikákat alkalmaz, amelyek megakadályozzák a képek észlelését és letöltését.",
    "A 'Kép Letöltő' kiterjesztés használata előtt kövesd az alábbi utasításokat, hogy biztosítsd, hogy a böngésző beállításai ne zavarják."
  ],
  "fr": [
    "Limitations",
    "(Toutes) les extensions ne fonctionnent pas sur des sites de téléchargement d'extensions tels que le Chrome Web Store et des sites non-URL comme la première page lorsque vous ouvrez un nouvel onglet.",
    "En général, seules les images chargées avant l'utilisation de l'extension peuvent être détectées.",
    "Si un site utilise une miniature, il est fort probable que vous ne puissiez pas capturer l'image plus grande.",
    "Certains sites utilisent des techniques spéciales qui empêchent la détection et le téléchargement des images.",
    "Avant d'utiliser l'extension 'Téléchargeur d'Images', suivez les instructions ci-dessous pour vous assurer que les paramètres du navigateur n'interfèrent pas."
  ],
  "it": [
    "Limitazioni",
    "(Tutte) le estensioni non funzionano su siti di download di componenti aggiuntivi come il Chrome Web Store e su siti non-URL come la prima pagina quando apri una nuova scheda.",
    "Di solito, solo le immagini caricate prima di utilizzare l'estensione possono essere rilevate.",
    "Se un sito utilizza una miniatura, è molto probabile che non sarai in grado di catturare l'immagine più grande.",
    "Alcuni siti utilizzano tecniche speciali che impediscono il rilevamento e il download delle immagini.",
    "Prima di utilizzare l'estensione 'Scaricatore di Immagini', segui le istruzioni qui sotto per assicurarti che le impostazioni del browser non interferiscano."
  ],
  "ja": [
    "制限事項",
    "(すべての)拡張機能は、Chrome Web Storeなどのアドオンダウンロードサイトや、新しいタブを開いたときの最初のページのような非URLサイトでは動作しません。",
    "通常、拡張機能を使用する前に読み込まれた画像のみが検出されます。",
    "サイトがサムネイルを使用している場合、大きな画像をキャプチャできない可能性が高いです。",
    "一部のサイトでは、画像の検出やダウンロードを防ぐ特別な技術が使用されています。",
    "拡張機能を使用する前に、下記の手順に従って、ブラウザの設定が干渉しないようにしてください。"
  ],
  "ko": [
    "제한 사항",
    "(모든) 확장 프로그램은 Chrome 웹 스토어와 같은 추가 기능 다운로드 사이트와 새 탭을 열 때 표시되는 첫 번째 페이지와 같은 비-URL 사이트에서 작동하지 않습니다.",
    "일반적으로 확장 프로그램을 사용하기 전에 로드된 이미지만 감지할 수 있습니다.",
    "사이트가 썸네일을 사용하는 경우, 큰 이미지를 캡처할 수 없을 가능성이 큽니다.",
    "일부 사이트는 이미지 감지 및 다운로드를 방지하는 특별한 기술을 사용합니다.",
    "확장 프로그램을 사용하기 전에 아래 지침을 따라 브라우저 설정이 방해되지 않도록 하세요."
  ],
  "ru": [
    "Ограничения",
    "(Все) расширения не работают на сайтах для загрузки дополнений, таких как Chrome Web Store, и на не-URL сайтах, таких как первая страница при открытии новой вкладки.",
    "Обычно только изображения, загруженные до использования расширения, могут быть обнаружены.",
    "Если сайт использует миниатюру, скорее всего, вы не сможете захватить более крупное изображение.",
    "Некоторые сайты используют специальные методы, которые предотвращают обнаружение и загрузку изображений.",
    "Перед использованием расширения следуйте инструкциям ниже, чтобы убедиться, что настройки браузера не мешают."
  ],
  "pt": [
    "Limitações",
    "(Todas) as extensões não funcionam em sites de download de complementos como a Chrome Web Store e em sites não-URL como a primeira página quando você abre uma nova aba.",
    "Normalmente, apenas as imagens carregadas antes de usar a extensão podem ser detectadas.",
    "Se um site usa uma miniatura, é muito provável que você não consiga capturar a imagem maior.",
    "Alguns sites utilizam técnicas especiais que impedem a detecção e o download de imagens.",
    "Antes de usar a extensão 'Baixador de Imagens', siga as instruções abaixo para garantir que as configurações do navegador não interfiram."
  ],
  "th": [
    "ข้อจำกัด",
    "(ทุก) ส่วนขยายไม่ทำงานบนเว็บไซต์ดาวน์โหลดส่วนขยายเช่น Chrome Web Store และเว็บไซต์ที่ไม่มี URL เช่นหน้าหลักเมื่อคุณเปิดแท็บใหม่",
    "โดยปกติแล้วจะตรวจจับได้เฉพาะภาพที่โหลดก่อนการใช้ส่วนขยาย",
    "หากเว็บไซต์ใช้ภาพขนาดย่อ คุณอาจไม่สามารถจับภาพขนาดใหญ่ได้",
    "บางเว็บไซต์ใช้เทคนิคพิเศษที่ป้องกันการตรวจจับและการดาวน์โหลดภาพ",
    "ก่อนใช้ส่วนขยายโปรดทำตามคำแนะนำด้านล่างเพื่อให้แน่ใจว่าไม่มีกำหนดค่าของเบราว์เซอร์ที่ขัดขวาง"
  ],
  "tr": [
    "Sınırlamalar",
    "(Tüm) uzantılar, Chrome Web Mağazası gibi eklenti indirme sitelerinde ve yeni bir sekme açtığınızda görünen ilk sayfalar gibi URL olmayan sitelerde çalışmaz.",
    "Genellikle, uzantıyı kullanmadan önce yüklenen resimler algılanabilir.",
    "Bir site küçük resim (thumbnail) kullanıyorsa, büyük resmi yakalayamayabilirsiniz.",
    "Bazı siteler, resimlerin tespiti ve indirilmesini engelleyen özel teknikler kullanır.",
    "Uzantıyı kullanmadan önce, tarayıcı ayarlarınızın müdahale etmediğinden emin olmak için aşağıdaki talimatları izleyin."
  ],
  "vi": [
    "Hạn chế",
    "(Tất cả) các tiện ích mở rộng không hoạt động trên các trang tải xuống tiện ích bổ sung như Chrome Web Store và các trang không phải URL như trang đầu tiên khi bạn mở một tab mới.",
    "Thông thường, chỉ những hình ảnh đã được tải trước khi sử dụng tiện ích mở rộng mới có thể được phát hiện.",
    "Nếu một trang sử dụng hình thu nhỏ, bạn rất có thể không thể chụp được hình ảnh lớn hơn.",
    "Một số trang web sử dụng các kỹ thuật đặc biệt ngăn chặn việc phát hiện và tải xuống hình ảnh.",
    "Trước khi sử dụng tiện ích mở rộng, vui lòng làm theo hướng dẫn dưới đây để đảm bảo rằng các cài đặt trình duyệt của bạn không can thiệp."
  ],
  "zh_CN": [
    "限制",
    "(所有)扩展程序无法在像Chrome Web商店这样的插件下载站点和没有URL的站点（如打开新标签页时的第一页）上工作。",
    "通常，只有在使用扩展程序之前加载的图像才能被检测到。",
    "如果网站使用缩略图，您很可能无法捕获较大的图像。",
    "一些网站使用特殊技术来防止检测和下载图像。",
    "在使用扩展程序之前，请按照下面的说明操作，以确保浏览器设置不会干扰。"
  ],
  "zh_TW": [
    "限制",
    "(所有)擴充功能無法在像是 Chrome Web 商店這類插件下載站點以及沒有 URL 的站點（例如當你開啟新分頁時的首頁）上運作。",
    "通常，只有在使用擴充功能之前已經加載的圖片才能被偵測到。",
    "如果一個網站使用縮圖，您很可能無法捕捉到較大的圖片。",
    "有些網站使用特殊技術來防止偵測和下載圖片。",
    "在使用擴充功能之前，請按照下面的說明操作，確保瀏覽器的設定不會干擾。"
  ]
};
    const checkSettings = {
        "en": [
          "Check browser settings",
          "On "," and "," go to ","settings -> downloads",", make sure that ","\"Ask where to save each file before downloading\""," is turned ","off",".",
          "On "," go to ","settings -> general -> files and applications",", make sure that ","\"Always ask you where to save files\""," is ","unchecked","."
        ],
        "de": [
          "Überprüfen Sie die Browsereinstellungen",
          "Gehen Sie in "," und "," zu "," Einstellungen -> Downloads",", stellen Sie sicher, dass ","\"Vor dem Download von Dateien nach dem Speicherort fragen\""," auf ","aus"," gestellt ist.",
          "Gehen Sie in "," zu "," Einstellungen -> Allgemein -> Dateien und Anwendungen",", stellen Sie sicher, dass ","\"Jedes Mal nachfragen, wo eine Datei gespeichert werden soll\""," ","deaktiviert"," ist."
        ],
        "es": [
          "Verificar la configuración del navegador",
          "En "," y ",", ve a ","configuración -> descargas",", asegúrate de que ","\"Preguntar dónde se guardará cada archivo antes de descargarlo\""," esté ","desactivado",".",
          "En ",", ve a ","ajustes -> general -> archivos y aplicaciones",", asegúrate de que ","\"Preguntar siempre dónde guardar los archivos\""," esté ","desmarcado","."
        ],
        "he": [
          "בדוק את הגדרות הדפדפן",
          "ב-"," ו-"," עבור אל ","הגדרות -> הורדות",", ודא כי ","\"יש לשאול היכן לשמור כל קובץ לפני הורדתו\""," ","מכובה",".",
          "ב-"," עבור אל ","הגדרות -> כללי -> קבצים ויישומים",", ודא כי ","\"לשאול תמיד היכן לשמור קבצים\""," ","לא נבחר","."
        ],
        "hu": [
          "Ellenőrizze a böngésző beállításait",
          ""," és "," esetén lépjen a ","beállítások -> letöltések"," menübe, és győződjön meg arról, hogy ","\"A letöltés előtt kérdezze meg, hová mentse az adott fájlokat\""," ","kikapcsolva"," van.",
          ""," esetén lépjen a ","beállítások -> általános -> fájlok és alkalmazások"," menübe, és győződjön meg arról, hogy ","\"Mindig kérdezzen rá a fájlok letöltési helyére\""," ","nincs bepipálva","."
        ],
        "fr": [
          "Vérifiez les paramètres du navigateur",
          "Sur "," et ",", allez dans ","paramètres -> téléchargements",", assurez-vous que ","\"Toujours demander où enregistrer les fichiers\""," est ","désactivé",".",
          "Sur ",", allez dans ","paramètres -> général -> fichiers et applications",", assurez-vous que ","\"Toujours demander où enregistrer les fichiers\""," est ","décoché","."
        ],
        "it": [ 
          "Controlla le impostazioni del browser",
          "In "," e "," vai su ","impostazioni -> download",", assicurati che ","\"Chiedi dove salvare il file prima di scaricarlo\""," sia ","disattivato",".",
          "In "," vai su ","impostazioni -> generale -> file e applicazioni",", assicurati che ","\"Chiedi dove salvare ogni file\""," ","non sia selezionato","."
        ],
        "ja": [
          "ブラウザ設定を確認",
          "","と","では、","設定 -> ダウンロード","に移動し、","\"ダウンロード前に各ファイルの保存場所を確認する\"","が","オフ","になっていることを確認してください。",
          "","では、","設定 -> 一般 -> ファイルとプログラム","に移動し、","\"ファイルごとに保存先を指定する\"","が","オフ","になっていることを確認してください。"
        ],
        "ko": [
          "브라우저 설정 확인",
          "","과 ","에서 ","설정 -> 다운로드","로 이동하여 ","\"다운로드 전에 각 파일의 저장 위치 확인\"","가 ","꺼짐","으로 설정되어 있는지 확인하세요.",
          "","에서 ","설정 -> 일반 -> 파일 및 애플리케이션","으로 이동하여 ","\"파일을 저장할 위치를 항상 묻기\"","가 ","선택 해제됨","인지 확인하세요."
        ],
        "ru": [
          "Проверьте настройки браузера",
          "В "," и "," перейдите в ","настройки -> Скачанные файлы",", убедитесь, что ","\"Перед скачиванием спрашивать, куда сохранить файл\""," ","отключено",".",
          "В "," перейдите в ","настройки -> Основные -> файлы и приложения",", убедитесь, что ","\"Всегда выдавать запрос на сохранение файлов\""," отключено","."
        ],
        "pt": [
          "Verificar as configurações do navegador",
          "No "," e no ",", vá para ","configurações -> downloads",", certifique-se de que ","\"Perguntar onde salvar cada arquivo antes de fazer download\""," esteja ","desligado",".",
          "No ",", vá para ","configurações -> geral -> arquivos e aplicativos",", certifique-se de que ","\"Sempre perguntar onde salvar arquivos\""," esteja ","desmarcado","."
        ],
        "th": [
          "ตรวจสอบการตั้งค่าของเบราว์เซอร์",
          "ใน "," และ "," ไปที่ ","การตั้งค่า -> ดาวน์โหลด"," และตรวจสอบให้แน่ใจว่า ","\"สอบถามที่เก็บไฟล์ก่อนดาวน์โหลด\""," ","ปิดอยู่","",
          "ใน "," ไปที่ ","การตั้งค่า -> ทั่วไป -> ไฟล์และแอปพลิเคชัน"," และตรวจสอบให้แน่ใจว่า ","\"ถามคุณเสมอว่าจะบันทึกไฟล์ที่ไหน\""," ถูก ","ยกเลิกการเลือก",""
        ],
        "tr": [
          "Tarayıcı ayarlarını kontrol et",
          ""," ve ","'de ","ayarlar -> indirmeler"," sekmesine gidin, ","\"İndirmeden önce her dosyanın nereye kaydedileceğini sor\""," seçeneğinin ","kapalı"," olduğundan emin olun.",
          "","'ta ","ayarlar -> genel -> dosyalar ve uygulamalar"," sekmesine gidin, ","\"Dosyaların nereye kaydedileceğini her zaman sor\""," seçeneğinin ","işaretsiz"," olduğundan emin olun."
        ],
        "vi": [
          "Kiểm tra cài đặt trình duyệt",
          "Trên "," và ",", vào ","cài đặt -> Tệp đã tải xuống",", đảm bảo rằng ","\"Hỏi vị trí lưu từng tệp trước khi tải xuống\""," đã được ","tắt",".",
          "Trên ",", vào ","cài đặt -> Tổng quát -> Tập tin và ứng dụng",", đảm bảo rằng ","\"Luôn hỏi bạn nơi để lưu các tập tin\""," đã được ","bỏ chọn","."
        ],
        "zh_CN": [
          "检查浏览器设置",
          "在 "," 和 "," 上，进入 ","设置 -> 下载内容","，确保 ","\"下载前询问每个文件的保存位置\""," 被设置为 ","关闭","。",
          "在 "," 上，进入 ","设置 -> 常规 -> 文件与应用程序","，确保 ","\"总是询问保存至何处\""," 被 ","取消勾选","。"
        ],
        "zh_TW": [
          "檢查瀏覽器設置",
          "在 "," 和 "," 上，進入 ","設置 -> 下載","，確保 ","\"下載每個檔案前先詢問儲存位置\""," 被設置為 ","關閉","。",
          "在 "," 上，進入 ","設定 -> 一般 -> 檔案與應用程式","，確保 ","\"每次都問您要存到何處\""," 被 ","取消勾選","。"
        ]
      };
      const userGuideOpening = {
        "en": [
          "User guide",
          "To use the Image Downloader, press the extension icon. This will open the popup window (or side panel - see the Display submenu section) and start scanning the web page for images. The popup window is divided into 4 main parts: the main menu, the submenu, the results area and the lower bar, which features additional buttons and info.",
          "The first buttons in the main menu allow you to switch between submenus. They are followed by a counter that shows how many images were detected and match your current filters.",
          "You can select one or more images by clicking them in the results area. To download the selected images, click the \"Download Selected Images\" icon",
          ".",
          "To download all images currently displayed in the results area, click the \"Download All\" icon",
          ".",
          "To save your settings, click the \"Save\" icon",
          ".",
          "The last icon in the main menu",
          "opens a drop-down menu that contains, among other options, a link to this guide.",
          "Large images include an \"Open in New Tab\" icon ",
          " and a \"Remove Background\" icon",
          ". Clicking Remove Background copies the image URL to the clipboard and opens a third-party website where you can paste the URL to remove the image background.",
          "The various submenus allow you to filter images based on their properties and to adjust the extension's settings."
        ],
"pt": [
  "Guia do usuário",
  "Para usar o Descarregador de Imagens, clique no ícone da extensão. Isto abrirá a janela pop-up (ou painel lateral - consulte a secção do submenú Exibição) e iniciará a procura de imagens na página web. A janela pop-up está dividida em 4 partes principais: o menu principal, o submenu, a área de resultados e a barra inferior, que apresenta botões e informações adicionais.",
  "Os primeiros botões do menu principal permitem alternar entre os submenus. Eles são seguidos por um contador que mostra quantas imagens foram detetadas e correspondem aos seus filtros atuais.",
  "Pode selecionar uma ou mais imagens clicando nelas na área de resultados. Para descarregar as imagens selecionadas, clique no ícone \"Descarregar Imagens Selecionadas\"",
  ".",
  "Para descarregar todas as imagens exibidas atualmente na área de resultados, clique no ícone \"Descarregar Todas\"",
  ".",
  "Para guardar as suas definições, clique no ícone \"Guardar\"",
  ".",
  "O último ícone no menu principal",
  "abre um menu suspenso que contém, entre outras opções, uma ligação para este guia.",
  "Imagens grandes incluem um ícone \"Abrir num Novo Separador\" ",
  " e um ícone \"Remover Fundo\"",
  ". Clicar em Remover Fundo copia o URL da imagem para a área de transferência e abre um website de terceiros onde pode colar o URL para remover o fundo da imagem.",
  "Os vários submenus permitem-lhe filtrar imagens com base nas suas propriedades e ajustar as definições da extensão."
],
"es": [
  "Guía de usuario",
  "Para usar el Descargador de Imágenes, presione el ícono de la extensión. Esto abrirá la ventana emergente (o el panel lateral; consulte la sección del submenú Mostrar) y comenzará a escanear la página web en busca de imágenes. La ventana emergente está dividida en 4 partes principales: el menú principal, el submenú, el área de resultados y la barra inferior, que incluye botones e información adicionales.",
  "Los primeros botones del menú principal le permiten cambiar entre submenús. Van seguidos de un contador que muestra cuántas imágenes se detectaron y coinciden con sus filtros actuales.",
  "Puede seleccionar una o más imágenes haciendo clic en ellas en el área de resultados. Para descargar las imágenes seleccionadas, haga clic en el ícono \"Descargar imágenes seleccionadas\"",
  ".",
  "Para descargar todas las imágenes que se muestran actualmente en el área de resultados, haga clic en el ícono \"Descargar todo\"",
  ".",
  "Para guardar su configuración, haga clic en el ícono \"Guardar\"",
  ".",
  "El último ícono del menú principal",
  "abre un menú desplegable que contiene, entre otras opciones, un enlace a esta guía.",
  "Las imágenes grandes incluyen un ícono \"Abrir en una pestaña nueva\" ",
  " y un ícono \"Eliminar fondo\"",
  ". Al hacer clic en Eliminar fondo, se copia la URL de la imagen en el portapapeles y se abre un sitio web de terceros donde puede pegar la URL para eliminar el fondo de la imagen.",
  "Los distintos submenús le permiten filtrar imágenes según sus propiedades y ajustar la configuración de la extensión."
],
"fr": [
  "Guide de l'utilisateur",
  "Pour utiliser le Téléchargeur d'Images, cliquez sur l'icône de l'extension. Cela ouvrira la fenêtre contextuelle (ou le panneau latéral - voir la section du sous-menu Affichage) et lancera l'analyse de la page web à la recherche d'images. La fenêtre contextuelle est divisée en 4 parties principales : le menu principal, le sous-menu, la zone de résultats et la barre inférieure, qui présente des boutons et des informations supplémentaires.",
  "Les premiers boutons du menu principal vous permettent de basculer entre les sous-menus. Ils sont suivis d'un compteur qui indique le nombre d'images détectées et correspondant à vos filtres actuels.",
  "Vous pouvez sélectionner une ou plusieurs images en cliquant dessus dans la zone de résultats. Pour télécharger les images sélectionnées, cliquez sur l'icône « Télécharger les images sélectionnées »",
  ".",
  "Pour télécharger toutes les images actuellement affichées dans la zone de résultats, cliquez sur l'icône « Tout télécharger »",
  ".",
  "Pour enregistrer vos paramètres, cliquez sur l'icône « Enregistrer »",
  ".",
  "La dernière icône du menu principal",
  "ouvre un menu déroulant qui contient, entre autres options, un lien vers ce guide.",
  "Les grandes images incluent une icône « Ouvrir dans un nouvel onglet » ",
  " et une icône « Supprimer l'arrière-plan »",
  ". Cliquer sur Supprimer l'arrière-plan copie l'URL de l'image dans le presse-papiers et ouvre un site web tiers où vous pouvez coller l'URL pour supprimer l'arrière-plan de l'image.",
  "Les différents sous-menus vous permettent de filtrer les images en fonction de leurs propriétés et d'ajuster les paramètres de l'extension."
],
"de": [
  "Benutzerhandbuch",
  "Um den Bild-Downloader zu nutzen, klicken Sie auf das Erweiterungssymbol. Dadurch wird das Popup-Fenster (oder die Seitenleiste – siehe Abschnitt Anzeige-Untermenü) geöffnet und die Webseite nach Bildern durchsucht. Das Popup-Fenster ist in 4 Hauptteile unterteilt: das Hauptmenü, das Untermenü, den Ergebnisbereich und die untere Leiste, die zusätzliche Schaltflächen und Informationen enthält.",
  "Die ersten Schaltflächen im Hauptmenü ermöglichen das Wechseln zwischen den Untermenüs. Dahinter folgt ein Zähler, der anzeigt, wie viele Bilder erkannt wurden und Ihren aktuellen Filtern entsprechen.",
  "Sie können ein oder mehrere Bilder auswählen, indem Sie im Ergebnisbereich darauf klicken. Um die ausgewählten Bilder herunterzuladen, klicken Sie auf das Symbol „Ausgewählte Bilder herunterladen“",
  ".",
  "Um alle aktuell im Ergebnisbereich angezeigten Bilder herunterzuladen, klicken Sie auf das Symbol „Alle herunterladen“",
  ".",
  "Um Ihre Einstellungen zu speichern, klicken Sie auf das Symbol „Speichern“",
  ".",
  "Das letzte Symbol im Hauptmenü",
  "öffnet ein Drop-down-Menü, das unter anderem einen Link zu diesem Handbuch enthält.",
  "Große Bilder enthalten ein Symbol „In neuem Tab öffnen“ ",
  " und ein Symbol „Hintergrund entfernen“",
  ". Durch Klicken auf „Hintergrund entfernen“ wird die Bild-URL in die Zwischenablage kopiert und eine Website eines Drittanbieters geöffnet, auf der Sie die URL einfügen können, um den Bildhintergrund zu entfernen.",
  "Die verschiedenen Untermenüs ermöglichen es Ihnen, Bilder basierend auf ihren Eigenschaften zu filtern und die Einstellungen der Erweiterung anzupassen."
],
"it": [
  "Guida utente",
  "Per utilizzare il Downloader di Immagini, premi l'icona dell'estensione. Questo aprirà la finestra pop-up (o il pannello laterale - vedi la sezione del sottomenu Visualizzazione) e avvierà la scansione della pagina web alla ricerca di immagini. La finestra pop-up è divisa in 4 parti principali: il menu principal, il sottomenu, l'area dei risultati e la barra inferiore, che presenta pulsanti e informazioni aggiuntive.",
  "I primi pulsanti nel menu principale consentono di passare da un sottomenu all'altro. Sono seguiti da un contatore che mostra quante immagini sono state rilevate e corrispondono ai filtri correnti.",
  "Puoi selezionare una o più immagini cliccando su di esse nell'area dei risultati. Per scaricare le immagini selezionate, fai clic sull'icona \"Scarica immagini selezionate\"",
  ".",
  "Per scaricare tutte le immagini attualmente visualizzate nell'area dei risultati, fai clic sull'icona \"Scarica tutto\"",
  ".",
  "Per salvare le impostazioni, fai clic sull'icona \"Salva\"",
  ".",
  "L'ultima icona nel menu principale",
  "apre un menu a discesa che contiene, tra le altre opzioni, un collegamento a questa guida.",
  "Le immagini grandi includono un'icona \"Apri in una nuova scheda\" ",
  " e un'icona \"Rimuovi sfondo\"",
  ". Facendo clic su Rimuovi sfondo, l'URL dell'immagine viene copiato negli appunti e si apre un sito Web di terze parti in cui è possibile incollare l'URL per rimuovere lo sfondo dell'immagine.",
  "I vari sottomenu consentono di filtrare le immagini in base alle loro proprietà e di regolare le impostazioni dell'estensione."
],

"hu": [
  "Használati útmutató",
  "A Képletöltő használatához kattintson a bővítmény ikonjára. Ez megnyitja a felugró ablakot (vagy az oldalsávot - lásd a Megjelenítés almenü részt), és elkezdi keresni a képeket a weboldalon. A felugró ablak 4 fő részre van osztva: a főmenüre, az almenüre, a találati területre és az alsó sávra, amely további gombokat és információkat tartalmaz.",
  "A főmenü első gombjai lehetővé teszik az almenük közötti váltást. Ezeket egy számláló követi, amely megmutatja, hány kép került észlelésre, és felel meg a jelenlegi szűrőknek.",
  "Kijelölhet egy vagy több képet, ha rákattint a találati területen. A kijelölt képek letöltéséhez kattintson a \"Kijelölt képek letöltése\" ikonra",
  ".",
  "A találati területen éppen megjelenített összes kép letöltéséhez kattintson a \"Mind letöltése\" ikonra",
  ".",
  "A beállítások mentéséhez kattintson a \"Mentés\" ikonra",
  ".",
  "A főmenü utolsó ikonja",
  "megnyit egy legördülő menüt, amely egyéb opciók mellett az ehhez az útmutatóhoz vezető linket is tartalmazza.",
  "A nagy képek tartalmaznak egy \"Megnyitás új lapon\" ikont ",
  " és egy \"Háttér eltávolítása\" ikont",
  ". A Háttér eltávolítása gombra kattintva a kép URL-je a vágólapra másolódik, és megnyílik egy harmadik fél weboldala, ahová beillesztheti az URL-t a kép hátterének eltávolításához.",
  "A különböző almenük lehetővé teszik a képek szűrését a tulajdonságaik alapján, valamint a bővítmény beállításainak módosítását."
],
"tr": [
  "Kullanıcı kılavuzu",
  "Resim İndirici'yi kullanmak için uzantı simgesine basın. Bu işlem, açılır pencereyi (veya yan paneli - Görünüm alt menüsü bölümüne bakın) açacak ve web sayfasındaki resimleri taramaya başlayacaktır. Açılır pencere 4 ana bölüme ayrılmıştır: ana menü, alt menü, sonuçlar alanı ve ek düğmeler ile bilgilerin yer aldığı alt çubuk.",
  "Ana menüdeki ilk düğmeler, alt menüler arasında geçiş yapmanızı sağlar. Bu düğmeleri, algılanan ve mevcut filtrelerinizle eşleşen resim sayısını gösteren bir sayaç takip eder.",
  "Sonuçlar alanındaki resimlere tıklayarak bir veya daha fazla resim seçebilirsiniz. Seçilen resimleri indirmek için \"Seçilen Resimleri İndir\" simgesine tıklayın",
  ".",
  "Şu anda sonuçlar alanında görüntülenen tüm resimleri indirmek için \"Tümünü İndir\" simgesine tıklayın",
  ".",
  "Ayarlarınızı kaydetmek için \"Kaydet\" simgesine tıklayın",
  ".",
  "Ana menüdeki son simge",
  "diğer seçeneklerin yanı sıra bu kılavuza giden bir bağlantı içeren bir açılır menü açar.",
  "Büyük resimler, \"Yeni Sekmede Aç\" simgesi ",
  " ve \"Arka Planı Kaldır\" simgesi içerir",
  ". Arka Planı Kaldır seçeneğine tıklandığında resim URL'si panoya kopyalanır ve resim arka planını kaldırmak için URL'yi yapıştırabileceğiniz üçüncü taraf bir web sitesi açılır.",
  "Çeşitli alt menüler, resimleri özelliklerine göre filtrelemenize ve uzantının ayarlarını düzenlemenize olanak tanır."
],
"ru": [
  "Руководство пользователя",
  "Чтобы использовать Загрузчик Изображений, нажмите на иконку расширения. Это откроет всплывающее окно (или боковую панель — см. раздел подменю «Отображение») и запустит сканирование веб-страницы на наличие изображений. Всплывающее окно разделено на 4 основные части: главное меню, подменю, область результатов и нижняя панель с дополнительными кнопками и информацией.",
  "Первые кнопки в главном меню позволяют переключаться между подменю. За ними следует счетчик, показывающий, сколько изображений обнаружено и соответствует вашим текущим фильтрам.",
  "Вы можете выбрать одно или несколько изображений, кликнув по ним в области результатов. Чтобы скачать выбранные изображения, нажмите на иконку «Скачать выбранные изображения»",
  ".",
  "Чтобы скачать все изображения, отображаемые в данный момент в области результатов, нажмите на иконку «Скачать все»",
  ".",
  "Чтобы сохранить настройки, нажмите на иконку «Сохранить»",
  ".",
  "Последняя иконка в главном меню",
  "открывает выпадающее меню, которое, помимо прочих опций, содержит ссылку на это руководство.",
  "Большие изображения содержат иконку «Открыть в новой вкладке» ",
  " и иконку «Удалить фон»",
  ". Нажатие на «Удалить фон» копирует URL изображения в буфер обмена и открывает сторонний сайт, где вы можете вставить этот URL для удаления фона изображения.",
  "Различные подменю позволяют фильтровать изображения по их свойствам и настраивать параметры расширения."
],
"he": [
  "מדריך למשתמש",
  "כדי להשתמש במוריד התמונות, לחץ על אייקון התוסף. זה יפתח את החלון הקופץ (או את סרגל הצד - ראה סעיף תפריט המשנה תצוגה) ויתחיל לסרוק את דף האינטרנט לאיתור תמונות. החלון הקופץ מחולק ל-4 חלקים עיקריים: התפריט הראשי, תפריט המשנה, אזור התוצאות והסרגל התחתון, הכולל כפתורים ומידע נוספים.",
  "הכפתורים הראשונים בתפריט הראשי מאפשרים לעבור בין תפריטי המשנה. אחריהם מופיע מונה המציג כמה תמונות זוהו ותואמות למסננים הנוכחיים שלך.",
  "ניתן לבחור תמונה אחת או יותר על ידי לחיצה עליהן באזור התוצאות. כדי להוריד את התמונות שנבחרו, לחץ על האייקון \"הורד תמונות שנבחרו\"",
  ".",
  "כדי להוריד את כל התמונות המוצגות כעת באזור התוצאות, לחץ על האייקון \"הורד הכל\"",
  ".",
  "כדי לשמור את ההגדרות שלך, לחץ על האייקון \"שמור\"",
  ".",
  "האייקון האחרון בתפריט הראשי",
  "פותח תפריט נפתח שמכיל, בין היתר, קישור למדריך זה.",
  "תמונות גדולות כוללות אייקון \"פתח בלשונית חדשה\" ",
  " ואייקון \"הסר רקע\"",
  ". לחיצה על \"הסר רקע\" מעתיקה את כתובת האתר של התמונה ללוח ופותחת אתר אינטרנט של צד שלישי שבו ניתן להדביק את כתובת האתר כדי להסיר את רקע התמונה.",
  "תפריטי המשנה השונים מאפשרים לך לסנן תמונות בהתבסס על המאפיינים שלהן ולהתאים את הגדרות התוסף."
],
"th": [
  "คู่มือผู้ใช้",
  "หากต้องการใช้โปรแกรมดาวน์โหลดรูปภาพ ให้กดที่ไอคอนส่วนขยาย ซึ่งจะเปิดหน้าต่างป็อปอัป (หรือแผงด้านข้าง - ดูที่ส่วนเมนูย่อยการแสดงผล) และเริ่มสแกนหน้าเว็บเพื่อค้นหารูปภาพ หน้าต่างป็อปอัปแบ่งออกเป็น 4 ส่วนหลัก ได้แก่ เมนูหลัก เมนูย่อย พื้นที่แสดงผลลัพธ์ และแถบด้านล่างซึ่งมีปุ่มและข้อมูลเพิ่มเติม",
  "ปุ่มแรกๆ ในเมนูหลักจะช่วยให้คุณสามารถสลับไปมาระหว่างเมนูย่อยได้ ตามด้วยตัวนับที่แสดงจำนวนรูปภาพที่ตรวจพบและตรงกับตัวกรองปัจจุบันของคุณ",
  "คุณสามารถเลือกรูปภาพหนึ่งรูปหรือมากกว่าได้โดยคลิกที่รูปภาพเหล่านั้นในพื้นที่แสดงผลลัพธ์ หากต้องการดาวน์โหลดรูปภาพที่เลือก ให้คลิกที่ไอคอน \"ดาวน์โหลดรูปภาพที่เลือก\"",
  ".",
  "หากต้องการดาวน์โหลดรูปภาพทั้งหมดที่แสดงอยู่ในพื้นที่ผลลัพธ์ขณะนี้ ให้คลิกที่ไอคอน \"ดาวน์โหลดทั้งหมด\"",
  ".",
  "หากต้องการบันทึกการตั้งค่าของคุณ ให้คลิกที่ไอคอน \"บันทึก\"",
  ".",
  "ไอคอนสุดท้ายในเมนูหลัก",
  "จะเปิดเมนูแบบเลื่อนลงซึ่งมีลิงก์ไปยังคู่มือนี้รวมอยู่ด้วยในบรรดาตัวเลือกอื่นๆ",
  "รูปภาพขนาดใหญ่จะมีไอคอน \"เปิดในแท็บใหม่\" ",
  " และไอคอน \"ลบพื้นหลัง\"",
  ". การคลิก ลบพื้นหลัง จะเป็นการคัดลอก URL ของรูปภาพไปยังคลิปบอร์ด และเปิดเว็บไซต์บุคคลที่สามที่คุณสามารถวาง URL เพื่อลบพื้นหลังของรูปภาพได้",
  "เมนูย่อยต่างๆ ช่วยให้คุณสามารถกรองรูปภาพตามคุณสมบัติของรูปภาพและปรับแต่งการตั้งค่าของส่วนขยายได้"
],
"vi": [
  "Hướng dẫn sử dụng",
  "Để sử dụng Trình tải xuống hình ảnh, hãy nhấn vào biểu tượng tiện ích mở rộng. Thao tác này sẽ mở cửa sổ bật lên (hoặc bảng điều khiển bên cạnh - xem phần menu phụ Hiển thị) và bắt đầu quét trang web để tìm hình ảnh. Cửa sổ bật lên được chia thành 4 phần chính: menu chính, menu phụ, vùng kết quả và thanh bên dưới, chứa các nút và thông tin bổ sung.",
  "Các nút đầu tiên trong menu chính cho phép bạn chuyển đổi giữa các menu phụ. Theo sau chúng là một bộ đếm hiển thị số lượng hình ảnh được phát hiện và khớp với các bộ lọc hiện tại của bạn.",
  "Bạn có thể chọn một hoặc nhiều hình ảnh bằng cách nhấp vào chúng trong vùng kết quả. Để tải xuống các hình ảnh đã chọn, hãy nhấp vào biểu tượng \"Tải xuống các hình ảnh đã chọn\"",
  ".",
  "Để tải xuống tất cả hình ảnh hiện đang hiển thị trong vùng kết quả, hãy nhấp vào biểu tượng \"Tải xuống tất cả\"",
  ".",
  "Để lưu cài đặt của bạn, hãy nhấp vào biểu tượng \"Lưu\"",
  ".",
  "Biểu tượng cuối cùng trong menu chính",
  "mở một menu thả xuống chứa, cùng với các tùy chọn khác, một liên kết đến hướng dẫn này.",
  "Hình ảnh lớn bao gồm biểu tượng \"Mở trong tab mới\" ",
  " và biểu tượng \"Xóa nền\"",
  ". Nhấp vào Xóa nền sẽ sao chép URL hình ảnh vào bộ nhớ tạm và mở một trang web bên thứ ba nơi bạn có thể dán URL để xóa nền hình ảnh.",
  "Các menu phụ khác nhau cho phép bạn lọc hình ảnh dựa trên các thuộc tính của chúng và điều chỉnh cài đặt của tiện ích mở rộng."
],
"ko": [
  "사용자 가이드",
  "이미지 다운로더를 사용하려면 확장 프로그램 아이콘을 누르세요. 이렇게 하면 팝업 창(또는 사이드 패널 - 디스플레이 하위 메뉴 섹션 참조)이 열리고 웹 페이지에서 이미지 스캔이 시작됩니다. 팝업 창은 메인 메뉴, 하위 메뉴, 결과 영역, 추가 버튼 및 정보가 있는 하단 바의 4가지 주요 부분으로 나뉩니다.",
  "메인 메뉴의 첫 번째 버튼을 사용하면 하위 메뉴 간에 전환할 수 있습니다. 그 뒤에는 감지되어 현재 필터와 일치하는 이미지 수를 보여주는 카운터가 표시됩니다.",
  "결과 영역에서 이미지를 클릭하여 하나 이상의 이미지를 선택할 수 있습니다. 선택한 이미지를 다운로드하려면 \"선택한 이미지 다운로드\" 아이콘을 클릭하세요.",
  ".",
  "현재 결과 영역에 표시된 모든 이미지를 다운로드하려면 \"모두 다운로드\" 아이콘을 클릭하세요.",
  ".",
  "설정을 저장하려면 \"저장\" 아이콘을 클릭하세요.",
  ".",
  "메인 메뉴의 마지막 아이콘은",
  "다른 옵션과 함께 이 가이드로 이동하는 링크가 포함된 드롭다운 메뉴를 엽니다.",
  "큰 이미지에는 \"새 탭에서 열기\" 아이콘 ",
  " 및 \"배경 제거\" 아이콘이 포함되어 있습니다.",
  ". 배경 제거를 클릭하면 이미지 URL이 클립보드에 복사되고, 이미지 배경을 제거하기 위해 URL을 붙여넣을 수 있는 타사 웹사이트가 열립니다.",
  "다양한 하위 메뉴를 통해 이미지 속성을 기준으로 이미지를 필터링하고 확장 프로그램 설정을 조정할 수 있습니다."
],
"zh_CN": [
  "用户指南",
  "要使用图片下载器，请点击扩展程序图标。这将打开弹出窗口（或侧边栏 - 参见“显示”子菜单部分）并开始扫描网页中的图像。弹出窗口分为 4 个主要部分：主菜单、子菜单、结果区域和包含附加按钮及信息的底栏。",
  "主菜单中的前几个按钮允许您在子菜单之间切换。紧随其后的是一个计数器，显示检测到并符合您当前过滤条件的图像数量。",
  "您可以在结果区域中点击一张或多张图像进行选择。要下载选中的图像，请点击“下载选中图像”图标",
  "。",
  "要下载当前在结果区域中显示的所有图像，请点击“下载全部”图标",
  "。",
  "要保存您的设置，请点击“保存”图标",
  "。",
  "主菜单中的最后一个图标",
  "会打开一个下拉菜单，其中包含指向此指南的链接等其他选项。",
  "大图包含“在新标签页中打开”图标 ",
  " 和“删除背景”图标",
  "。点击“删除背景”会将图像 URL 复制到剪贴板，并打开一个第三方网站，您可以在该网站上粘贴 URL 以删除图像背景。",
  "各种子菜单允许您根据图像属性过滤图像并调整扩展程序的设置。"
],
"zh_TW": [
  "使用者指南",
  "要使用圖片下載器，請點擊擴充功能圖示。這將打開彈出式視窗（或側邊欄 - 參見「顯示」子選單部分）並開始掃描網頁中的圖片。彈出式視窗分為 4 個主要部分：主選單、子選單、結果區域和包含附加按鈕及資訊的底欄。",
  "主選單中的前幾個按鈕允許您在子選單之間切換。緊隨其後的是一個計數器，顯示偵測到並符合您目前篩選條件的圖片數量。",
  "您可以在結果區域中點擊一張或多張圖片進行選擇。要下載選取的圖片，請點擊「下載選取圖片」圖示",
  "。",
  "要下載目前在結果區域中顯示的所有圖片，請點擊「下載全部」圖示",
  "。",
  "要儲存您的設定，請點擊「儲存」圖示",
  "。",
  "主選單中的最後一個圖示",
  "會打開一個下拉式選單，其中包含指向此指南的連結等其他選項。",
  "大圖包含「在新分頁中開啟」圖示 ",
  " 和「移除背景」圖示",
  "。點擊「移除背景」會將圖片 URL 複製到剪貼簿，並開啟一個第三方網站，您可以在該網站上貼上 URL 以移除圖片背景。",
  "各種子選單允許您根據圖片屬性篩選圖片並調整擴充功能的設定。"
],
"ja": [
  "ユーザーガイド",
  "画像ダウンローダーを使用するには、拡張機能のアイコンを押してください。これによりポップアップウィンドウ（またはサイドパネル - 「表示」サブメニュー의のセクションを参照）が開き、ウェブページ内の画像のスキャンが開始されます。ポップアップウィンドウは、メインメニュー、サブメニュー、結果エリア、および追加のボタンや情報が表示される下部バーの4つの主要な部分に分かれています。",
  "メインメニューの最初のいくつかのボタンで、サブメニューを切り替えることができます。その後に、検出され、現在のフィルターに一致した画像の数を示すカウンターが表示されます。",
  "結果エリアで画像をクリックすると、1つまたは複数の画像を選択できます。選択した画像をダウンロードするには、「選択した画像をダウンロード」アイコンをクリックします",
  "。",
  "現在結果エリアに表示されているすべての画像をダウンロードするには、「すべてダウンロード」アイコンをクリックします",
  "。",
  "設定を保存するには、「保存」アイコンをクリックします",
  "。",
  "メインメニューの最後のアイコンは",
  "ドロップダウンメニューを開き、他のオプションに加えて、このガイドへのリンクが含まれています。",
  "大きい画像には「新しいタブで開く」アイコン ",
  " と「背景を削除」アイコンが含まれています",
  "。「背景を削除」をクリックすると、画像のURLがクリップボードにコピーされ、URLを貼り付けて画像の背景を削除できるサードパーティのウェブサイトが開きます。",
  "さまざまなサブメニューを使用して、画像の特徴に基づいて画像をフィルター処理したり、拡張機能の設定を調整したりできます。"
]
      }
      const size = {
        "en": ["Size submenu","This submenu is opened by default, use it to filter images by pixel width and height. You can use the ","S M L A ","buttons to quickly set the filter settings to show ","S","mall, ", "M","edium, ","L"
          ,"arge, or ","A","ll images. Leave the max values empty if you don't want to set an upper limit."],
          "ja": [
            "サイズサブメニュー",
            "このサブメニューはデフォルトで開かれており、ピクセル幅と高さで画像をフィルターするために使用します。"," S M L A ",
            "ボタンを使用すると、フィルター設定をすばやく設定して、小さい",
            " (S)、",
            "中",
            " (M)、",
            "大きい",
            " (L)、",
            "またはすべての画像",
            " (A)",
            " を表示できます。上限を設定しない場合は、最大値を空のままにしておきます。"
        ],
        "ko": [
          "크기 하위 메뉴",
          "이 하위 메뉴는 기본적으로 열리며, 픽셀 너비와 높이로 이미지를 필터링하는 데 사용합니다. ",
          "S M L A ",
          "버튼을 사용하여 필터 설정을 빠르게 설정하여 작은",
          " (S), ",
          "중간",
          " (M), ",
          "큰",
          " (L), ",
          "또는 모든 이미지",
          " (A)",
          "를 표시할 수 있습니다. 상한을 설정하지 않으려면 최대값을 비워 둡니다."
      ],
      "th": [
        "เมนูย่อยขนาด",
        "เมนูย่อยนี้จะเปิดขึ้นตามค่าเริ่มต้น ใช้เพื่อกรองภาพตามความกว้างและความสูงแบบพิกเซล คุณสามารถใช้ปุ่ม ",
        "S M L A ",
        "เพื่อตั้งค่าตัวกรองอย่างรวดเร็วเพื่อแสดงภาพขนาดเล็ก",
        " (S), ",
        "ขนาดกลาง",
        " (M), ",
        "ขนาดใหญ่",
        " (L), ",
        "หรือภาพทั้งหมด",
        " (A)",
        " ปล่อยค่าสูงสุดว่างไว้หากคุณไม่ต้องการตั้งค่าขีดจำกัดสูงสุด."
    ],
    "vi": [
      "Menu phụ kích thước", 
      "Menu phụ này được mở theo mặc định, sử dụng để lọc hình ảnh theo chiều rộng và chiều cao pixel. Bạn có thể sử dụng các nút ", 
      "S M L A ", 
      "để nhanh chóng thiết lập cài đặt bộ lọc để hiển thị nhỏ", 
      " (S), ", 
      "trung bình", 
      " (M), ", 
      "lớn", 
      " (L), ", 
      "hoặc tất cả hình ảnh", 
      " (A)", 
      ". Để trống các giá trị tối đa nếu bạn không muốn đặt giới hạn trên."
  ],
  "zh_CN": [
    "大小子菜单",
    "此子菜单默认打开，使用它按像素宽度和高度过滤图像。您可以使用 ",
    "S M L A ",
    "按钮快速设置过滤器设置以显示小",
    " (S)、",
    "中",
    " (M)、",
    "大",
    " (L) ",
    "或所有图像",
    " (A)",
    "。如果您不想设置上限，请将最大值留空。"
],
"he": [
  "תת-תפריט גודל ",
  "תפריט משנה זה נפתח כברירת מחדל, השתמש בו כדי לסנן תמונות לפי רוחב וגובה פיקסלים. אתה יכול להשתמש בלחצני-",
  " S M L A ",
  "כדי להגדיר במהירות את הגדרות הסינון כך שיציגו תמונות קטנות",
  " (S), ",
  "בינוניות",
  " (M), ",
  "גדולות",
  " (L), ",
  "או את כל התמונות",
  " (A)",
  ". השאר את ערכי המקסימום ריקים אם אינך רוצה להגדיר גבול עליון."
],
"tr": [
  "Boyut alt menüsü",
  "Bu alt menü varsayılan olarak açıktır, bunu görüntüleri piksel cinsinden genişlik ve yüksekliğe göre filtrelemek için kullanın. Filtre ayarlarını küçük",
  " (S)"," orta"," (M)",", büyük"," (L)"," veya tüm resimleri"," (A)"," görüntüleyecek şekilde hızlıca ayarlamak için ",
  "S M L A ",
  "düğmelerini kullanabilirsiniz."
],
"de": [
  "Untermenü „Größe“",
  "Dieses Untermenü ist standardmäßig geöffnet. Filtern Sie Bilder nach Pixelbreite und -höhe. Mit den ",
  "Schaltflächen „S M L A“ ",
  "können Sie die Filtereinstellungen schnell so einstellen, dass nur kleine",
  " (S), ",
  "mittlere",
  " (M), ",
  "große",
  " (L) ",
  "oder alle Bilder",
  " (A) ",
  "angezeigt werden. Lassen Sie die Maximalwerte leer, wenn Sie keine Obergrenze festlegen möchten."
],
"it": [
  "Sottomenu Dimensioni",
  "Questo sottomenu è aperto di default, utilizzalo per filtrare le immagini in base alla larghezza e all'altezza dei pixel. Puoi usare i pulsanti",
  " S M L A ",
  "per impostare rapidamente le impostazioni del filtro per mostrare piccole",
  " (S), ",
  "medie",
  " (M), ",
  "grandi",
  " (L), ",
  "o tutte le immagini",
  " (A)",
  ". Lascia i valori massimi vuoti se non vuoi impostare un limite superiore."
],
"fr": [
  "Sous-menu Taille",
  "Ce sous-menu est ouvert par défaut. Utilisez-le pour filtrer les images par largeur et hauteur en pixels. Vous pouvez utiliser les boutons",
  " S, M, L, A ",
  "pour définir rapidement les paramètres de filtre et afficher les images de petite taille",
  " (S), ",
  "moyennes",
  " (M), ",
  "grandes",
  " (L), ",
  "ou toutes les images",
  " (A)",
  ". Laissez les valeurs maximales vides si vous ne souhaitez pas définir de limite supérieure."
],
"pt": [
  "Submenu Tamanho",
  "Este submenu é aberto por padrão, use-o para filtrar imagens por largura e altura de pixel. Você pode usar os botões ",
  "S M L A ",
  "para definir rapidamente as configurações do filtro para mostrar pequeno"," (S), ",
  "médio"," (M), ",
  "grande"," (L), ",
  "ou todas as imagens"," (A)",". Deixe os valores máximos vazios se não quiser definir um limite superior."
],
"es": ["Submenú Tamaño", "Este submenú se abre por defecto. Úselo para filtrar imágenes por ancho y alto en píxeles. Puede usar los botones"," S M L A ", "para configurar rápidamente el filtro y mostrar imágenes pequeñas", " (S), ", "medianas", " (M), ", "grandes", " (L), ", "o todas", " (A)", ". Deje los valores máximos en blanco si no desea establecer un límite superior."],
"hu": ["Méret almenü","Ez az almenü alapértelmezés szerint megnyílik, ezzel szűrheti a képeket pixelszélesség és -magasság szerint. Az ","S M L A ","gombokkal gyorsan beállíthatja a szűrőbeállításokat úgy, hogy kicsi"," (S), ","közepes"," (M), ","nagy"," (L) ","vagy az összes kép"," (A) ","jelenjen meg. Ha nem akar felső határt beállítani, hagyja üresen a maximális értékeket."],
"zh_TW": ["大小子選單", "此子選單預設為打開，使用它來按像素寬度和高度過濾圖像。您可以使用 ", "S M L A ", "按鈕快速設定濾鏡設定以顯示小", " (S)、", "中", " (M)、", "大", " (L)、", "或所有影像", " (A)。", "如果不想設定上限，請將最大值留空。"],
"ru": ["Подменю размера","Это подменю открыто по умолчанию, используйте его для фильтрации изображений по ширине и высоте в пикселях. Вы можете использовать кнопки ","S M L A",", чтобы быстро задать настройки фильтра для отображения маленьких"," (S), ","средних"," (M), ","больших"," (L), ","или всех изображений"," (A)",". Оставьте максимальные значения пустыми, если вы не хотите устанавливать верхний предел."],
          "temp": ["Size submenu","This submenu is opened by default, use it to filter images by pixel width and height. You can use the ","S M L A ","buttons to quickly set the filter settings to show small"," (S), ","medium"," (M), ","large"," (L), ","or all images"," (A)",". Leave the max values empty if you don't want to set an upper limit."]
      };
      const typeLayout = {
      "en": [
    "Type submenu",
    "Here you set the file extensions you want to filter.",
    "Layout submenu",
    "You can use this submenu to filter images based on orientation by pressing one of the left buttons, or more specifically by width to height ratio by changing the sign and value in the input box. Leave the ratio empty to show all ratios (or just press the \"All\" button)."
  ],
  "pt": [
    "Submenu de tipo",
    "Aqui você define as extensões de arquivo que deseja filtrar.",
    "Submenu de layout",
    "Você pode usar este submenu para filtrar imagens com base na orientação pressionando um dos botões à esquerda, ou mais especificamente pela proporção largura-altura, alterando o sinal e o valor na caixa de entrada. Deixe a proporção vazia para mostrar todas as proporções (ou simplesmente pressione o botão \"Todos\")."
  ],
  "es": [
    "Submenú de tipo",
    "Aquí configuras las extensiones de archivo que deseas filtrar.",
    "Submenú de diseño",
    "Puedes usar este submenú para filtrar imágenes según la orientación presionando uno de los botones de la izquierda, o más específicamente por la relación de ancho a alto cambiando el signo y el valor en el cuadro de entrada. Deja la relación vacía para mostrar todas las proporciones (o simplemente presiona el botón \"Todos\")."
  ],
  "fr": [
    "Sous-menu Type",
    "Ici, vous définissez les extensions de fichier que vous souhaitez filtrer.",
    "Sous-menu Disposition",
    "Vous pouvez utiliser ce sous-menu pour filtrer les images en fonction de l'orientation en appuyant sur l'un des boutons à gauche, ou plus spécifiquement en fonction du rapport largeur/hauteur en modifiant le signe et la valeur dans la boîte de saisie. Laissez le rapport vide pour afficher tous les rapports (ou appuyez simplement sur le bouton \"Tous\")."
  ],
  "de": [
    "Typ-Untermenü",
    "Hier legen Sie die Dateierweiterungen fest, die Sie filtern möchten.",
    "Layout-Untermenü",
    "Sie können dieses Untermenü verwenden, um Bilder nach ihrer Ausrichtung zu filtern, indem Sie eine der linken Tasten drücken, oder genauer gesagt nach dem Breiten-Höhen-Verhältnis, indem Sie das Vorzeichen und den Wert im Eingabefeld ändern. Lassen Sie das Verhältnis leer, um alle Verhältnisse anzuzeigen (oder drücken Sie einfach die Schaltfläche \"Alle\")."
  ],
  "it": [
    "Sottomenu Tipo",
    "Qui imposti le estensioni di file che desideri filtrare.",
    "Sottomenu Layout",
    "Puoi usare questo sottomenu per filtrare le immagini in base all'orientamento premendo uno dei pulsanti a sinistra, o più precisamente in base al rapporto larghezza-altezza modificando il segno e il valore nella casella di input. Lascia il rapporto vuoto per mostrare tutti i rapporti (o premi semplicemente il pulsante \"Tutti\")."
  ],
  "hu": [
    "Típus almenü",
    "Itt állíthatja be a szűrni kívánt fájlkiterjesztéseket.",
    "Elrendezés almenü",
    "Ezt az almenüt használhatja a képek tájolás szerinti szűrésére a bal oldali gombok egyikének megnyomásával, vagy konkrétabban a szélesség-magasság arány alapján a jel és az érték megváltoztatásával a beviteli mezőben. Hagyja üresen az arányt az összes arány megjelenítéséhez (vagy egyszerűen nyomja meg az \"Összes\" gombot)."
  ],
  "tr": [
    "Tür alt menüsü",
    "Burada filtrelemek istediğiniz dosya uzantılarını ayarlarsınız.",
    "Düzen alt menüsü",
    "Bu alt menüyü kullanarak görüntüleri yönelime göre filtreleyebilir veya daha spesifik olarak genişlik-yükseklik oranına göre işaret ve değeri giriş kutusunda değiştirerek filtreleyebilirsiniz. Tüm oranları göstermek için oranı boş bırakın (veya sadece \"Tümü\" düğmesine basın)."
  ],
  "ru": [
    "Подменю типа",
    "Здесь вы устанавливаете расширения файлов, которые хотите отфильтровать.",
    "Подменю макета",
    "Вы можете использовать это подменю для фильтрации изображений по ориентации, нажав одну из кнопок слева, или более конкретно – по соотношению ширины к высоте, изменяя знак и значение в поле ввода. Оставьте поле пустым, чтобы показать все соотношения (или просто нажмите кнопку \"Все\")."
  ],
  "he": [
    "תת-תפריט סוג",
    "כאן ניתן להגדיר את סיומות הקבצים שברצונך לסנן.",
    "תת-תפריט פריסה",
    "באפשרותך להשתמש בתת-תפריט זה כדי לסנן תמונות לפי כיוון באמצעות לחיצה על אחד מהלחצנים השמאליים, או באופן ספציפי יותר לפי יחס רוחב-גובה על ידי שינוי הסימן והערך בתיבת הקלט. השאר את היחס ריק כדי להציג את כל היחסים (או פשוט לחץ על כפתור \"הכל\")."
  ],
  "vi": [
    "Trình đơn phụ loại",
    "Tại đây bạn thiết lập các phần mở rộng tệp muốn lọc.",
    "Trình đơn phụ bố cục",
    "Bạn có thể sử dụng trình đơn phụ này để lọc hình ảnh dựa trên hướng bằng cách nhấn một trong các nút bên trái, hoặc cụ thể hơn là theo tỷ lệ chiều rộng và chiều cao bằng cách thay đổi dấu và giá trị trong hộp nhập. Để trống tỷ lệ để hiển thị tất cả các tỷ lệ (hoặc chỉ cần nhấn nút \"Tất cả\")."
  ],
  "th": [
    "เมนูย่อยประเภท",
    "ที่นี่คุณสามารถตั้งค่าส่วนขยายไฟล์ที่คุณต้องการกรอง",
    "เมนูย่อยเค้าโครง",
    "คุณสามารถใช้เมนูย่อยนี้เพื่อกรองรูปภาพตามแนวการวาง โดยกดปุ่มด้านซ้าย หรือกรองตามอัตราส่วนความกว้างต่อความสูงโดยเปลี่ยนเครื่องหมายและค่าที่กล่องป้อนข้อมูล ปล่อยอัตราส่วนว่างไว้เพื่อแสดงทุกอัตราส่วน (หรือกดปุ่ม \"ทั้งหมด\")"
  ],
  "ko": [
    "유형 하위 메뉴",
    "여기에서 필터링할 파일 확장자를 설정할 수 있습니다.",
    "레이아웃 하위 메뉴",
    "이 하위 메뉴를 사용하여 왼쪽 버튼 중 하나를 눌러 이미지 방향별로 필터링하거나, 입력 상자에서 기호와 값을 변경하여 너비 대비 높이 비율별로 더 구체적으로 필터링할 수 있습니다. 모든 비율을 표시하려면 비율을 비워두세요 (또는 '모두' 버튼을 누르세요)."
  ],
  "zh_CN": [
    "类型子菜单",
    "在这里设置要过滤的文件扩展名。",
    "布局子菜单",
    "您可以使用此子菜单通过按左侧按钮按方向筛选图片，或者更具体地通过更改输入框中的符号和值按宽高比进行筛选。留空比率以显示所有比例（或直接按“全部”按钮）。"
  ],
  "zh_TW": [
    "類型子選單",
    "在這裡設定要過濾的檔案副檔名。",
    "佈局子選單",
    "您可以使用此子選單透過按左側按鈕依方向篩選圖片，或更具體地透過更改輸入框中的符號和值依寬高比篩選。留空比例以顯示所有比例（或直接按「全部」按鈕）。"
  ],
  "ja": [
    "タイプサブメニュー",
    "ここでフィルタリングしたいファイル拡張子を設定します。",
    "レイアウトサブメニュー",
    "このサブメニューを使用すると、左のボタンを押して画像を向きでフィルタリングするか、入力ボックスで符号と値を変更して、幅と高さの比率でより具体的にフィルタリングできます。比率を空のままにすると、すべての比率が表示されます（または「すべて」ボタンを押してください）。"
  ]
}
const advanced = {
  "en": ["Advanced submenu",
    "The Image Downloader extension offers advanced filtering options, such as filtering images based on partial URL matches. You can choose to include or exclude images whose URLs contain a specific sequence. To disable this filter, leave the URL field empty. You can also press the clean icon ",
    " to remove all URLs. ",
    "To match a URL using multiple terms, separate them with a semicolon (without spaces). For example: wikipedia;google;pixabay.",
    "Another advanced filtering option in this submenu is filtering by image version. Some websites provide alternative versions of an image, typically in different sizes. Here, you can choose which version to capture. By default, the extension captures the largest version that meets your other filters. Other options include capturing the smallest version, all versions, or only those with unique dimensions."],
    "pt": ["Submenu avançado",
      "A extensão Baixador de imagens oferece opções avançadas de filtragem, como filtrar imagens com base em correspondências parciais de URL. Você pode escolher incluir ou excluir imagens cujos URLs contenham uma sequência específica. Para desabilitar esse filtro, deixe o campo URL vazio. Você também pode pressionar o ícone de limpeza ",
      " para remover todos os URLs. ",
      "Para corresponder a um URL usando vários termos, separe-os com ponto e vírgula (sem espaços). Por exemplo: wikipedia;google;pixabay.",
      "Outra opção avançada de filtragem neste submenu é filtrar por versão da imagem. Alguns sites fornecem versões alternativas de uma imagem, normalmente em tamanhos diferentes. Aqui, você pode escolher qual versão capturar. Por padrão, a extensão captura a maior versão que atende aos seus outros filtros. Outras opções incluem capturar a menor versão, todas as versões ou apenas aquelas com dimensões exclusivas."],
      "es": ["Submenú avanzado",
        "La extensión Descargador de Imágenes ofrece opciones avanzadas de filtrado, como el filtrado de imágenes basado en coincidencias parciales de URL. Puede incluir o excluir imágenes cuyas URL contengan una secuencia específica. Para desactivar este filtro, deje el campo de URL vacío. También puede pulsar el icono de limpieza ",
        " para eliminar todas las URL. ",
        "Para buscar coincidencias con una URL utilizando varios términos, sepárelos con punto y coma (sin espacios). Por ejemplo: wikipedia;google;pixabay.",
        "Otra opción avanzada de filtrado en este submenú es el filtrado por versión de la imagen. Algunos sitios web ofrecen versiones alternativas de una imagen, generalmente en diferentes tamaños. Aquí puede elegir qué versión capturar. Por defecto, la extensión captura la versión más grande que cumple con los otros filtros. Otras opciones incluyen capturar la versión más pequeña, todas las versiones o solo aquellas con dimensiones únicas."],
          "fr": ["Sous-menu Avancé",
            "L'extension Téléchargeur d'images propose des options de filtrage avancées, comme le filtrage des images en fonction des correspondances d'URL partielles. Vous pouvez choisir d'inclure ou d'exclure les images dont les URL contiennent une séquence spécifique. Pour désactiver ce filtre, laissez le champ URL vide. Vous pouvez également appuyer sur l'icône de nettoyage ",
            " pour supprimer toutes les URL. ",
            "Pour rechercher une URL contenant plusieurs termes, séparez-les par un point-virgule (sans espace). Par exemple : wikipedia;google;pixabay.",
            "Une autre option de filtrage avancée de ce sous-menu est le filtrage par version d'image. Certains sites web proposent des versions alternatives d'une image, généralement dans des tailles différentes. Vous pouvez choisir la version à capturer. Par défaut, l'extension capture la version la plus grande correspondant à vos autres filtres. Vous pouvez également capturer la version la plus petite, toutes les versions ou uniquement celles ayant des dimensions uniques."],
              "de": ["Erweitert",
                "Die Erweiterung „Bild-Downloader“ bietet erweiterte Filteroptionen, beispielsweise das Filtern von Bildern anhand von teilweisen URL-Übereinstimmungen. Sie können Bilder, deren URLs eine bestimmte Sequenz enthalten, ein- oder ausschließen. Um diesen Filter zu deaktivieren, lassen Sie das URL-Feld leer. Alternativ können Sie auf das Löschsymbol klicken ",
                ", um alle URLs zu entfernen. ",
                "Um eine URL mit mehreren Begriffen abzugleichen, trennen Sie diese durch ein Semikolon (ohne Leerzeichen). Beispiel: wikipedia;google;pixabay.",
                "Eine weitere erweiterte Filteroption in diesem Untermenü ist das Filtern nach Bildversion. Einige Websites bieten alternative Versionen eines Bildes an, typischerweise in unterschiedlichen Größen. Hier können Sie auswählen, welche Version erfasst werden soll. Standardmäßig erfasst die Erweiterung die größte Version, die Ihren anderen Filtern entspricht. Weitere Optionen sind die Erfassung der kleinsten Version, aller Versionen oder nur der Versionen mit unterschiedlichen Abmessungen."],
                "it": ["Sottomenu avanzato",
                  "L'estensione Scaricatore di immagini offre opzioni di filtro avanzate, come il filtraggio delle immagini in base alle corrispondenze parziali degli URL. Puoi scegliere di includere o escludere le immagini i cui URL contengono una sequenza specifica. Per disattivare questo filtro, lascia vuoto il campo URL. Puoi anche premere l'icona di pulizia ",
                  " per rimuovere tutti gli URL. ",
                  "Per abbinare un URL utilizzando più termini, separali con un punto e virgola (senza spazi). Ad esempio: wikipedia;google;pixabay.",
                  "Un'altra opzione di filtro avanzata in questo sottomenu è il filtro per versione dell'immagine. Alcuni siti Web forniscono versioni alternative di un'immagine, in genere in diverse dimensioni. Qui puoi scegliere quale versione catturare. Per impostazione predefinita, l'estensione cattura la versione più grande che soddisfa gli altri filtri. Altre opzioni includono la cattura della versione più piccola, di tutte le versioni o solo di quelle con dimensioni univoche."],
                  "hu": ["Speciális almenü",
                    "Az Képletöltő bővítmény speciális szűrési lehetőségeket kínál, például a képek szűrését részleges URL-egyezések alapján. Dönthet úgy, hogy felveszi vagy kizárja azokat a képeket, amelyek URL-je meghatározott sorozatot tartalmaz. A szűrő letiltásához hagyja üresen az URL mezőt. Az összes URL eltávolításához megnyomhatja a tiszta ikont is",
                    ". Ha több kifejezést használ egy URL-hez, pontosvesszővel válassza el őket (szóközök nélkül). Például: wikipedia;google;pixabay.",
                    "","Egy másik speciális szűrési lehetőség ebben az almenüben a képverzió szerinti szűrés. Egyes webhelyek a képek alternatív változatait kínálják, jellemzően különböző méretekben. Itt kiválaszthatja, hogy melyik verziót rögzítse. Alapértelmezés szerint a bővítmény a legnagyobb verziót rögzíti, amely megfelel a többi szűrőjének. További lehetőségek közé tartozik a legkisebb verzió, az összes verzió vagy csak az egyedi méretű verziók rögzítése."],
                    "tr": ["Gelişmiş alt menü",
                      "Resim İndirici uzantısı, kısmi URL eşleşmelerine göre görüntüleri filtreleme gibi gelişmiş filtreleme seçenekleri sunar. URL'leri belirli bir dizi içeren görüntüleri dahil etmeyi veya hariç tutmayı seçebilirsiniz. Bu filtreyi devre dışı bırakmak için URL alanını boş bırakın. Ayrıca tüm URL'leri kaldırmak için temiz simgesine basabilirsiniz ",
                      ". Birden fazla terim kullanarak bir URL'yi eşleştirmek için bunları noktalı virgülle (boşluksuz) ayırın. Örneğin: wikipedia;google;pixabay.",
                      ,"Bu alt menüdeki bir diğer gelişmiş filtreleme seçeneği de görüntü sürümüne göre filtrelemedir. Bazı web siteleri, genellikle farklı boyutlarda bir görüntünün alternatif sürümlerini sağlar. Burada, hangi sürümü yakalayacağınızı seçebilirsiniz. Varsayılan olarak, uzantı diğer filtrelerinizi karşılayan en büyük sürümü yakalar. Diğer seçenekler arasında en küçük sürümü, tüm sürümleri veya yalnızca benzersiz boyutlara sahip olanları yakalamak yer alır."],
                      "ru": ["Расширенное подменю",
                        "Расширение Загрузчик изображений предлагает расширенные параметры фильтрации, такие как фильтрация изображений на основе частичных совпадений URL. Вы можете включить или исключить изображения, URL-адреса которых содержат определенную последовательность. Чтобы отключить этот фильтр, оставьте поле URL пустым. Вы также можете нажать значок очистки ",
                        ", чтобы удалить все URL-адреса. ",
                        "Чтобы сопоставить URL-адрес с несколькими терминами, разделите их точкой с запятой (без пробелов). Например: wikipedia;google;pixabay.",
                        "Еще один расширенный параметр фильтрации в этом подменю — фильтрация по версии изображения. Некоторые веб-сайты предоставляют альтернативные версии изображения, как правило, разных размеров. Здесь вы можете выбрать, какую версию захватывать. По умолчанию расширение захватывает самую большую версию, которая соответствует вашим другим фильтрам. Другие параметры включают захват самой маленькой версии, всех версий или только тех, которые имеют уникальные размеры."],
                        "he": ["תת-תפריט מתקדם",
                          "תוסף הורדת התמונות מציע אפשרויות סינון מתקדמות, כגון סינון תמונות על סמך התאמות חלקיות של כתובות אתרים. אתה יכול לבחור לכלול או לא לכלול תמונות שכתובות האתר שלהן מכילות רצף מסוים. כדי להשבית מסנן זה, השאר את שדה כתובת האתר ריק. אתה יכול גם ללחוץ על האייקון נקה ",
                          " כדי להסיר את כל כתובות האתרים. ",
                          "כדי להתאים כתובת אתר באמצעות מונחים מרובים, הפרד אותם באמצעות נקודה-פסיק (ללא רווחים). לדוגמה: wikipedia;google;pixabay.",
                          "אפשרות סינון מתקדמת נוספת בתת תפריט זה היא סינון לפי גרסת תמונה. חלק מהאתרים מספקים גרסאות חלופיות של תמונה, בדרך כלל בגדלים שונים. כאן, אתה יכול לבחור איזו גרסה ללכוד. כברירת מחדל, התוסף לוכד את הגרסה הגדולה ביותר העונה למסננים האחרים שלך. אפשרויות אחרות כוללות לכידת הגרסה הקטנה ביותר, כל הגרסאות, או רק אלה עם ממדים ייחודיים."],
                          "th": ["เมนูย่อยขั้นสูง",
                            "ส่วนขยายโปรแกรมดาวน์โหลดรูปภาพมีตัวเลือกการกรองขั้นสูง เช่น การกรองรูปภาพตามการจับคู่ URL บางส่วน คุณสามารถเลือกที่จะรวมหรือไม่รวมรูปภาพที่ URL มีลำดับเฉพาะ หากต้องการปิดใช้งานตัวกรองนี้ ให้ปล่อยช่อง URL ว่างไว้ นอกจากนี้ คุณยังสามารถกดไอคอน ",
                            " เพื่อลบ URL ทั้งหมดได้อีกด้วย ",
                            "หากต้องการจับคู่ URL โดยใช้คำหลายคำ ให้คั่นด้วยเครื่องหมายเซมิโคลอน (โดยไม่เว้นวรรค) ตัวอย่างเช่น wikipedia;google;pixabay",
                            "ตัวเลือกการกรองขั้นสูงอีกตัวเลือกหนึ่งในเมนูย่อยนี้คือการกรองตามเวอร์ชันของรูปภาพ เว็บไซต์บางแห่งมีเวอร์ชันทางเลือกของรูปภาพ โดยปกติจะมีขนาดต่างกัน ที่นี่ คุณสามารถเลือกเวอร์ชันที่จะจับภาพได้ โดยค่าเริ่มต้น ส่วนขยายจะจับภาพเวอร์ชันที่ใหญ่ที่สุดที่ตรงกับตัวกรองอื่นๆ ของคุณ ตัวเลือกอื่นๆ ได้แก่ จับภาพเวอร์ชันที่เล็กที่สุด เวอร์ชันทั้งหมด หรือเฉพาะเวอร์ชันที่มีขนาดเฉพาะ"],
                            "vi": ["Menu phụ nâng cao",
                              "Phần mở rộng trình tải xuống hình ảnh cung cấp các tùy chọn lọc nâng cao, chẳng hạn như lọc hình ảnh dựa trên các URL trùng khớp một phần. Bạn có thể chọn bao gồm hoặc loại trừ hình ảnh có URL chứa một chuỗi cụ thể. Để tắt bộ lọc này, hãy để trống trường URL. Bạn cũng có thể nhấn vào biểu tượng ",
                              " để xóa tất cả các URL. ",
                              "Để khớp một URL bằng nhiều thuật ngữ, hãy phân tách chúng bằng dấu chấm phẩy (không có khoảng trắng). Ví dụ: wikipedia;google;pixabay.",
                              "Một tùy chọn lọc nâng cao khác trong menu phụ này là lọc theo phiên bản hình ảnh. Một số trang web cung cấp các phiên bản thay thế của hình ảnh, thường ở các kích thước khác nhau. Tại đây, bạn có thể chọn phiên bản nào để chụp. Theo mặc định, phần mở rộng sẽ chụp phiên bản lớn nhất đáp ứng các bộ lọc khác của bạn. Các tùy chọn khác bao gồm chụp phiên bản nhỏ nhất, tất cả các phiên bản hoặc chỉ những phiên bản có kích thước duy nhất."],
                              "ko": ["고급 하위 메뉴",
                                "이미지 다운로더 확장 프로그램은 부분 URL 일치에 따라 이미지를 필터링하는 것과 같은 고급 필터링 옵션을 제공합니다. URL에 특정 시퀀스가 포함된 이미지를 포함하거나 제외하도록 선택할 수 있습니다. 이 필터를 비활성화하려면 URL 필드를 비워 둡니다. 아이콘을 눌러 ",
                                " 모든 URL을 제거할 수도 있습니다. ",
                                "여러 용어를 사용하여 URL을 일치시키려면 세미콜론(공백 없음)으로 구분합니다. 예: wikipedia;google;pixabay.",
                                "이 하위 메뉴의 또 다른 고급 필터링 옵션은 이미지 버전별 필터링입니다. 일부 웹사이트는 일반적으로 크기가 다른 대체 버전의 이미지를 제공합니다. 여기에서 캡처할 버전을 선택할 수 있습니다. 기본적으로 확장 프로그램은 다른 필터를 충족하는 가장 큰 버전을 캡처합니다. 다른 옵션으로는 가장 작은 버전, 모든 버전 또는 고유한 크기가 있는 버전만 캡처하는 것이 있습니다."],
                                "ja": ["詳細サブメニュー",
                                  "画像ダウンローダー拡張機能には、部分的な URL 一致に基づいて画像をフィルタリングするなど、高度なフィルタリング オプションがあります。URL に特定のシーケンスが含まれる画像を含めるか除外するかを選択できます。このフィルタを無効にするには、URL フィールドを空のままにします。アイコンを押して ",
                                  " すべての URL を削除することもできます。",
                                  "複数の用語を使用して URL を一致させるには、セミコロン (スペースなし) で区切ります。例: wikipedia;google;pixabay。",
                                  "このサブメニューのもう 1 つの高度なフィルタリング オプションは、画像バージョンによるフィルタリングです。一部の Web サイトでは、通常は異なるサイズの画像の代替バージョンが提供されています。ここで、キャプチャするバージョンを選択できます。デフォルトでは、拡張機能は他のフィルタを満たす最大のバージョンをキャプチャします。その他のオプションには、最小バージョン、すべてのバージョン、または一意の寸法を持つバージョンのみをキャプチャすることが含まれます。"],
                                  "zh_CN": ["高级子菜单",
                                    "图像下载器扩展程序提供高级过滤选项，例如根据部分 URL 匹配过滤图像。您可以选择包含或排除 URL 包含特定序列的图像。要禁用此过滤器，请将 URL 字段留空。您也可以按图标 ",
                                    " 删除所有 URL。",
                                    "要使用多个术语匹配 URL，请用分号（不带空格）分隔它们。例如：wikipedia;google;pixabay。",
                                    "此子菜单中的另一个高级过滤选项是按图像版本过滤。一些网站提供图像的替代版本，通常大小不同。在这里，您可以选择要捕获哪个版本。默认情况下，扩展程序会捕获符合其他过滤器的最大版本。其他选项包括捕获最小版本、所有版本或仅捕获具有唯一尺寸的版本。"],
                                    "zh_TW": ["進階子選單",
                                      "圖像下載器擴充功能提供了高級過濾選項，例如根據部分 URL 匹配過濾圖像。您可以選擇包含或排除 URL 包含特定序列的圖像。若要停用此過濾器，請將 URL 欄位留空。您也可以按圖示刪除所有 URL ",
                                      " 。若要使用多個術語來匹配 URL，請用分號（不含空格）分隔它們。例如：wikipedia；google；pixabay。","",
                                      "此子選單中的另一個進階過濾選項是按影像版本過濾。一些網站提供圖像的替代版本，通常尺寸不同。在這裡，您可以選擇要捕獲哪個版本。預設情況下，擴充功能會捕捉符合其他濾鏡的最大版本。其他選項包括捕獲最小版本、所有版本或僅捕獲具有獨特尺寸的版本。"]
                                  };
    const save = {
      'en':["(Save config) submenu","Here you can set the folders, file names, and auto-conversion of file formats.",
        "All folders are saved in your downloads folder. By default each time you download an image the extension generates an increasing number as a folder name, made from the date and time. You can also set a custom folder (inside your downloads folder) and choose a custom file name. In addition, folders and files can be automatically named using site addresses, dates, prefix names, and more. To configure these options, use the Save Path Wizard",
        "To set the auto format converter, press the convert icon ",
        ". In the pop-up window that opens, choose the file format to convert to. You can convert to JPEG, PNG, or WebP. For JPEG and WebP, you can also set the quality between 1 and 10, with 10 being the highest quality and 1 being the smallest file size. PNG is a lossless format, so the quality is always set to 10."],
        "ja": ["(設定を保存)サブメニュー",
          "ここでは、フォルダー、ファイル名、ファイル形式の自動変換を設定できます。",
          "すべてのフォルダーはダウンロードフォルダーに保存されます。デフォルトでは、画像をダウンロードするたびに、拡張機能が日時に基づいた連番をフォルダー名として生成します。カスタムフォルダー（ダウンロードフォルダー内）を設定し、カスタムファイル名を選択することもできます。さらに、フォルダーやファイルは、サイトアドレス、日付、プレフィックス名などを使用して自動的に名前付けできます。これらのオプションを設定するには、保存パスウィザードを使用してください。",
          "自動フォーマットコンバーターを設定するには、変換アイコンを押します",
          "。開いたポップアップウィンドウで、変換するファイル形式を選択します。JPEG、PNG、WebP に変換できます。JPEG と WebP の場合、品質を 1 ～ 10 の間で設定することもできます。10 が最高品質、1 が最小ファイルサイズになります。PNG はロスレス形式なので、品質は常に 10 に設定されます。"],
          "zh_CN": ["（保存配置）子菜单",
            "在这里您可以设置文件夹、文件名以及文件格式的自动转换。",
            "所有文件夹都会保存在您的下载文件夹中。默认情况下，每次下载图片时，扩展程序都会根据日期和时间生成一个递增的数字作为文件夹名称。您还可以设置自定义文件夹（位于您的下载文件夹内）并选择自定义文件名。此外，文件夹和文件还可以根据网站地址、日期、前缀名称等自动命名。要配置这些选项，请使用保存路径向导。",
            "要设置自动格式转换器，请按转换图标 ",
            "。在打开的弹出窗口中，选择要转换的文件格式。您可以转换为 JPEG、PNG 或 WebP。对于 JPEG 和 WebP，您还可以将质量设置为 1 到 10 之间，其中 10 表示最高质量，1 表示最小文件大小。PNG 是无损格式，因此质量始终设置为 10。"],
            "zh_TW": ["（儲存配置）子選單",
    "在這裡您可以設定資料夾、檔案名稱以及檔案格式的自動轉換。",
    "所有資料夾都會儲存在您的下載資料夾中。預設情況下，每次下載圖片時，擴充功能都會根據日期和時間產生一個遞增的數字作為資料夾名稱。您也可以設定自訂資料夾（位於您的下載資料夾內）並選擇自訂檔案名稱。此外，資料夾和檔案還可以根據網站地址、日期、前綴名稱等自動命名。若要設定這些選項，請使用儲存路徑精靈。",
    "若要設定自動格式轉換器，請按轉換圖示 ",
    "。在開啟的彈出視窗中，選擇要轉換的檔案格式。您可以轉換為 JPEG、PNG 或 WebP。對於 JPEG 和 WebP，您還可以將品質設為 1 到 10 之間，其中 10 表示最高品質，1 表示最小檔案大小。PNG 是無損格式，因此品質始終設定為 10。"],
    "ko": ["(구성 저장) 하위 메뉴",
      "여기서 폴더, 파일 이름, 파일 형식의 자동 변환을 설정할 수 있습니다.",
      "모든 폴더는 다운로드 폴더에 저장됩니다. 기본적으로 이미지를 다운로드할 때마다 확장 프로그램은 날짜와 시간을 기반으로 증가하는 번호를 폴더 이름으로 생성합니다. 또한 사용자 지정 폴더(다운로드 폴더 내부)를 설정하고 사용자 지정 파일 이름을 선택할 수 있습니다. 추가로, 폴더와 파일은 사이트 주소, 날짜, 접두사 이름 등을 사용하여 자동으로 이름이 지정될 수 있습니다. 이러한 옵션을 구성하려면 저장 경로 마법사를 사용하세요.",
      "자동 형식 변환기를 설정하려면 변환 아이콘을 누르세요 ",
      ". 팝업창이 열리면 변환할 파일 형식을 선택합니다. JPEG, PNG 또는 WebP로 변환할 수 있습니다. JPEG 및 WebP의 경우 품질을 1~10 사이로 설정할 수 있으며, 10이 가장 높은 품질이고 1이 가장 작은 파일 크기가 됩니다. PNG는 손실 없는 형식이므로 품질은 항상 10으로 설정됩니다."],
      "vi": ["(Lưu cấu hình) menu phụ",
        "Tại đây bạn có thể thiết lập thư mục, tên tệp và tự động chuyển đổi định dạng tệp.",
        "Tất cả thư mục được lưu trong thư mục tải xuống của bạn. Theo mặc định, mỗi khi bạn tải xuống một hình ảnh, tiện ích mở rộng sẽ tạo một số tăng dần làm tên thư mục, dựa trên ngày và giờ. Bạn cũng có thể đặt một thư mục tùy chỉnh (bên trong thư mục tải xuống của bạn) và chọn tên tệp tùy chỉnh. Ngoài ra, thư mục và tệp có thể được tự động đặt tên bằng địa chỉ trang web, ngày tháng, tên tiền tố và nhiều hơn nữa. Để cấu hình các tùy chọn này, hãy sử dụng Trình hướng dẫn đường dẫn lưu.",
        "Để cài đặt trình chuyển đổi định dạng tự động, hãy nhấn vào biểu tượng chuyển đổi ",
        ". Trong cửa sổ bật lên mở ra, hãy chọn định dạng tệp để chuyển đổi. Bạn có thể chuyển đổi sang JPEG, PNG hoặc WebP. Đối với JPEG và WebP, bạn cũng có thể đặt chất lượng từ 1 đến 10, trong đó 10 là chất lượng cao nhất và 1 là kích thước tệp nhỏ nhất. PNG là định dạng không mất dữ liệu, vì vậy chất lượng luôn được đặt ở mức 10."],
        "th": ["เมนูย่อย (บันทึกการกำหนดค่า)",
          "คุณสามารถตั้งค่าโฟลเดอร์ ชื่อไฟล์ และการแปลงรูปแบบไฟล์อัตโนมัติได้ที่นี่",
          "โฟลเดอร์ทั้งหมดจะถูกบันทึกไว้ในโฟลเดอร์ดาวน์โหลดของคุณ ตามค่าเริ่มต้น ทุกครั้งที่คุณดาวน์โหลดรูปภาพ ส่วนขยายจะสร้างหมายเลขที่เพิ่มขึ้นเป็นชื่อโฟลเดอร์ โดยอ้างอิงจากวันที่และเวลา คุณยังสามารถตั้งค่าโฟลเดอร์แบบกำหนดเอง (ภายในโฟลเดอร์ดาวน์โหลดของคุณ) และเลือกชื่อไฟล์แบบกำหนดเองได้ นอกจากนี้ โฟลเดอร์และไฟล์ยังสามารถตั้งชื่อโดยอัตโนมัติโดยใช้ที่อยู่เว็บไซต์ วันที่ ชื่อคำนำหน้า และอื่น ๆ ได้อีกด้วย หากต้องการกำหนดค่าตัวเลือกเหล่านี้ ให้ใช้ตัวช่วยสร้างเส้นทางการบันทึก",
          "หากต้องการตั้งค่าตัวแปลงรูปแบบอัตโนมัติ ให้กดไอคอนแปลง ",
          " ในหน้าต่างป๊อปอัปที่เปิดขึ้น ให้เลือกรูปแบบไฟล์ที่จะแปลง คุณสามารถแปลงเป็น JPEG, PNG หรือ WebP ได้ สำหรับ JPEG และ WebP คุณยังสามารถตั้งค่าคุณภาพได้ระหว่าง 1 ถึง 10 โดย 10 คือคุณภาพสูงสุด และ 1 คือขนาดไฟล์ที่เล็กที่สุด PNG เป็นรูปแบบที่ไม่มีการสูญเสีย ดังนั้นคุณภาพจึงถูกตั้งเป็น 10 เสมอ."],
          "he": ["תת-תפריט הגדרות שמירה",
            "כאן אתה יכול להגדיר את התיקיות, שמות הקבצים והמרה אוטומטית של פורמטים של קבצים.",
            "כל התיקיות נשמרות בתיקיית ההורדות שלך. כברירת מחדל, בכל פעם שאתה מוריד תמונה, התוסף יוצר מספר עולה כשם תיקייה, המבוסס על התאריך והשעה. ניתן גם להגדיר תיקייה מותאמת אישית (בתוך תיקיית ההורדות שלך) ולבחור שם קובץ מותאם אישית. בנוסף, ניתן לתת שמות אוטומטיים לתיקיות ולקבצים באמצעות כתובות אתרים, תאריכים, שמות קידומת ועוד. כדי להגדיר אפשרויות אלו, השתמש באשף נתיב השמירה.",
            "כדי להגדיר את ממיר הפורמט האוטומטי, לחץ על סמל ההמרה ",
            ". בחלון המוקפץ שנפתח, בחר את פורמט הקובץ להמרה. אתה יכול להמיר ל-JPEG, PNG או WebP. עבור JPEG ו-WebP, אתה יכול גם להגדיר את האיכות בין 1 ל-10, כאשר 10 הוא האיכות הגבוהה ביותר ו-1 הוא גודל הקובץ הקטן ביותר. PNG הוא פורמט ללא אובדן, כך שהאיכות תמיד מוגדרת ל-10."],
            "ru": ["(Сохранить конфигурацию) подменю",
              "Здесь вы можете задать папки, имена файлов и автоматическое преобразование форматов файлов.",
              "Все папки сохраняются в вашей папке загрузок. По умолчанию каждый раз, когда вы загружаете изображение, расширение создаёт возрастающий номер в качестве имени папки на основе даты и времени. Вы также можете указать пользовательскую папку (внутри вашей папки загрузок) и выбрать пользовательское имя файла. Кроме того, папки и файлы могут автоматически именоваться с использованием адресов сайтов, дат, префиксов и многого другого. Чтобы настроить эти параметры, используйте мастер пути сохранения.",
              "Чтобы задать автоматический конвертер форматов, нажмите значок конвертации ",
              ". В открывшемся всплывающем окне выберите формат файла для конвертации. Вы можете конвертировать в JPEG, PNG или WebP. Для JPEG и WebP вы также можете установить качество в диапазоне от 1 до 10, где 10 — самое высокое качество, а 1 — самый маленький размер файла. PNG — это формат без потерь, поэтому качество всегда устанавливается на уровне 10."],
              "tr": ["(Yapılandırmayı kaydet) alt menüsü",
                "Burada klasörleri, dosya adlarını ve dosya biçimlerinin otomatik dönüştürülmesini ayarlayabilirsiniz.",
                "Tüm klasörler indirilenler klasörünüze kaydedilir. Varsayılan olarak, her bir resim indirdiğinizde uzantı, tarih ve saate göre oluşturulmuş artan bir sayıyı klasör adı olarak oluşturur. Ayrıca özel bir klasör (indirilenler klasörünüzün içinde) ayarlayabilir ve özel bir dosya adı seçebilirsiniz. Ek olarak, klasörler ve dosyalar site adresleri, tarihler, önek adları ve daha fazlası kullanılarak otomatik olarak adlandırılabilir. Bu seçenekleri yapılandırmak için Kaydetme yolu sihirbazını kullanın.",
                "Otomatik biçim dönüştürücüyü ayarlamak için dönüştür simgesine basın",
                ". Açılan açılır pencerede dönüştürülecek dosya biçimini seçin. JPEG, PNG veya WebP'ye dönüştürebilirsiniz. JPEG ve WebP için kaliteyi 1 ile 10 arasında da ayarlayabilirsiniz; 10 en yüksek kalite, 1 ise en küçük dosya boyutudur. PNG kayıpsız bir formattır, bu nedenle kalite her zaman 10 olarak ayarlanır."],
                "hu": ["(Konfiguráció mentése) almenü",
                  "Itt állíthatja be a mappákat, a fájlneveket és a fájlformátumok automatikus konvertálását.",
                  "Minden mappa a Letöltések mappába kerül mentésre. Alapértelmezés szerint minden alkalommal, amikor letöltesz egy képet, a bővítmény egy növekvő számot generál mappanévként, amely a dátumon és az időn alapul. Beállíthatsz egyéni mappát is (a Letöltések mappádon belül), és választhatsz egyéni fájlnevet. Emellett a mappák és fájlok automatikusan elnevezhetők webhelycímek, dátumok, előtagnevek és egyebek alapján. Ezeknek a beállításoknak a konfigurálásához használd a Mentési útvonal varázslót.",
                  "Az automatikus formátum konverter beállításához nyomja meg a konvertálás ikont ",
                  ". A megnyíló felugró ablakban válassza ki a konvertálni kívánt fájlformátumot. Konvertálhat JPEG, PNG vagy WebP formátumba. JPEG és WebP esetén a minőséget 1 és 10 között is beállíthatja, ahol a 10 a legjobb minőség, az 1 pedig a legkisebb fájlméret. A PNG veszteségmentes formátum, ezért a minőség mindig 10-re van állítva."],
                  "it": ["(Sottomenu Salva configurazione)",
                    "Qui puoi impostare le cartelle, i nomi dei file e la conversione automatica dei formati dei file.",
                    "Tutte le cartelle vengono salvate nella tua cartella Download. Per impostazione predefinita, ogni volta che scarichi un'immagine, l'estensione genera un numero crescente come nome della cartella, basato sulla data e sull'ora. Puoi anche impostare una cartella personalizzata (all'interno della tua cartella Download) e scegliere un nome file personalizzato. Inoltre, cartelle e file possono essere nominati automaticamente utilizzando indirizzi di siti, date, nomi prefisso e altro. Per configurare queste opzioni, usa la Procedura guidata del percorso di salvataggio.",
                    "Per impostare il convertitore di formato automatico, premi l'icona di conversione ",
                    ". Nella finestra pop-up che si apre, scegli il formato del file in cui convertire. Puoi convertire in JPEG, PNG o WebP. Per JPEG e WebP, puoi anche impostare la qualità tra 1 e 10, dove 10 è la qualità più alta e 1 è la dimensione minima del file. PNG è un formato lossless, quindi la qualità è sempre impostata su 10."],
                    "de": ["Untermenü (Konfiguration speichern)",
                      "Hier können Sie Ordner, Dateinamen und die automatische Konvertierung von Dateiformaten festlegen.",
                      "Alle Ordner werden in deinem Download-Ordner gespeichert. Standardmäßig generiert die Erweiterung jedes Mal, wenn du ein Bild herunterlädst, eine fortlaufende Nummer als Ordnernamen, basierend auf Datum und Uhrzeit. Du kannst auch einen benutzerdefinierten Ordner (innerhalb deines Download-Ordners) festlegen und einen benutzerdefinierten Dateinamen wählen. Außerdem können Ordner und Dateien automatisch anhand von Webseitenadressen, Daten, Präfixnamen und mehr benannt werden. Um diese Optionen zu konfigurieren, verwende den Assistenten für den Speicherpfad.",
                      "Um die automatische Formatkonvertierung einzustellen, klicken Sie auf das Konvertierungssymbol ",
                      ". Wählen Sie im sich öffnenden Popup-Fenster das zu konvertierende Dateiformat. Sie können in JPEG, PNG oder WebP konvertieren. Für JPEG und WebP können Sie die Qualität ebenfalls zwischen 1 und 10 einstellen, wobei 10 die höchste Qualität und 1 die kleinste Dateigröße darstellt. PNG ist ein verlustfreies Format, daher ist die Qualität immer auf 10 eingestellt."],
                      "fr": ["Sous-menu (Enregistrer la configuration)",
                        "Ce menu vous permet de définir les dossiers, les noms de fichiers et la conversion automatique des formats de fichiers.",
                        "Tous les dossiers sont enregistrés dans votre dossier de téléchargements. Par défaut, chaque fois que vous téléchargez une image, l’extension génère un numéro croissant comme nom de dossier, basé sur la date et l’heure. Vous pouvez également définir un dossier personnalisé (dans votre dossier de téléchargements) et choisir un nom de fichier personnalisé. De plus, les dossiers et les fichiers peuvent être nommés automatiquement à l’aide d’adresses de sites, de dates, de noms de préfixe, et plus encore. Pour configurer ces options, utilisez l’Assistant du chemin d’enregistrement.",
                        "Pour configurer le convertisseur de format automatique, appuyez sur l'icône de conversion ",
                        ". Dans la fenêtre contextuelle qui s'ouvre, choisissez le format de fichier à convertir. Vous pouvez convertir en JPEG, PNG ou WebP. Pour les formats JPEG et WebP, vous pouvez également définir la qualité entre 1 et 10, 10 correspondant à la qualité maximale et 1 à la taille minimale. Le PNG étant un format sans perte, la qualité est toujours fixée à 10."],
                        "es": ["Submenú (Guardar configuración)",
                          "Aquí puede configurar las carpetas, los nombres de los archivos y la conversión automática de formatos.",
                          "Todas las carpetas se guardan en tu carpeta de descargas. De forma predeterminada, cada vez que descargas una imagen, la extensión genera un número incremental como nombre de carpeta, basado en la fecha y la hora. También puedes establecer una carpeta personalizada (dentro de tu carpeta de descargas) y elegir un nombre de archivo personalizado. Además, las carpetas y los archivos pueden nombrarse automáticamente usando direcciones de sitios, fechas, nombres de prefijo y más. Para configurar estas opciones, utiliza el Asistente de ruta de guardado.",
                          "Para configurar el conversor de formato automático, pulse el icono de conversión ",
                          ". En la ventana emergente, seleccione el formato de archivo al que desea convertir. Puede convertir a JPEG, PNG o WebP. Para JPEG y WebP, también puede configurar la calidad entre 1 y 10, donde 10 representa la calidad más alta y 1 el tamaño de archivo más pequeño. PNG es un formato sin pérdida, por lo que la calidad siempre se establece en 10."],
                          "pt": ["(Salvar configuração) submenu",
    "Aqui você pode definir as pastas, nomes de arquivos e conversão automática de formatos de arquivo.",
    "Todas as pastas são salvas na sua pasta de downloads. Por padrão, cada vez que você baixa uma imagem, a extensão gera um número crescente como nome da pasta, baseado na data e na hora. Você também pode definir uma pasta personalizada (dentro da sua pasta de downloads) e escolher um nome de arquivo personalizado. Além disso, pastas e arquivos podem ser nomeados automaticamente usando endereços de sites, datas, nomes de prefixo e muito mais. Para configurar essas opções, use o Assistente de caminho de salvamento.",
    "Para definir o conversor de formato automático, pressione o ícone de conversão ",
    ". Na janela pop-up que se abre, escolha o formato de arquivo para o qual converter. Você pode converter para JPEG, PNG ou WebP. Para JPEG e WebP, você também pode definir a qualidade entre 1 e 10, com 10 sendo a qualidade mais alta e 1 sendo o menor tamanho de arquivo. PNG é um formato sem perdas, então a qualidade é sempre definida como 10."]
    };
    const display = {
      "en":["(Display) submenu","You can set here the following:",
        "Whether the extension opens in a popup or as a side panel (not available in Firefox). In side panel mode, the extension stays active even when switching tabs.",
        "The maximum width of the image in the result area (make it smaller to fit more images in the visible area at any given time).",
        "The theme.","The user interface language.","The sorting method of the images displayed.", "There are 8 methods of sorting to choose from:",
        "The default sorting, which roughly corresponds to the order of images on the page.", "Grouping by file type.", "Image width small to large.", "Image width large to small.",
        "Image height small to large.", "Image height large to small.", "Image pixel size small to large.", "Image pixel size large to small."],
        "he": ["תת-תפריט תצוגה", 
          "כאן ניתן להגדיר את האפשרויות הבאות:", 
          "האם ההרחבה תיפתח בחלון קופץ או כפאנל צד (לא זמין ב-Firefox). במצב פאנל צד, ההרחבה נשארת פעילה גם בעת מעבר בין כרטיסיות.", 
          "הרוחב המרבי של התמונה באזור התוצאות (הקטנת הערך תאפשר הצגת יותר תמונות באזור הגלוי בכל רגע נתון).", 
          "ערכת הנושא.", 
          "שפת ממשק המשתמש.",
          "שיטת המיון של התמונות המוצגות.",
  "ישנן 8 שיטות מיון לבחירה:",
  "מיון ברירת מחדל, שמתאים בערך לסדר התמונות בדף.",
  "קיבוץ לפי סוג קובץ.",
  "רוחב תמונה מהקטן לגדול.",
  "רוחב תמונה מהגדול לקטן.",
  "גובה תמונה מהקטן לגדול.",
  "גובה תמונה מהגדול לקטן.",
  "גודל פיקסלים של התמונה מהקטן לגדול.",
  "גודל פיקסלים של התמונה מהגדול לקטן."],
          "pt": ["(Exibição) submenu",
            "Aqui você pode configurar as seguintes opções:",
            "Se a extensão será aberta em um pop-up ou como um painel lateral (não disponível no Firefox). No modo painel lateral, a extensão permanece ativa mesmo ao alternar entre abas.",
            "A largura máxima da imagem na área de resultados (reduza para ajustar mais imagens na área visível a qualquer momento).",
            "O tema.",
            "O idioma da interface do usuário.",
              "O método de ordenação das imagens exibidas.",
  "Há 8 métodos de ordenação para escolher:",
  "A ordenação padrão, que corresponde aproximadamente à ordem das imagens na página.",
  "Agrupamento por tipo de arquivo.",
  "Largura da imagem de menor para maior.",
  "Largura da imagem de maior para menor.",
  "Altura da imagem de menor para maior.",
  "Altura da imagem de maior para menor.",
  "Tamanho em pixels da imagem de menor para maior.",
  "Tamanho em pixels da imagem de maior para menor."
          ],
          "es": ["(Visualización) submenú",
            "Aquí puede configurar las siguientes opciones:",
            "Si la extensión se abrirá en una ventana emergente o como un panel lateral (no disponible en Firefox). En modo panel lateral, la extensión permanece activa incluso al cambiar de pestañas.",
            "El ancho máximo de la imagen en el área de resultados (reduzca el valor para mostrar más imágenes en el área visible en un momento dado).",
            "El tema.",
            "El idioma de la interfaz de usuario.",
              "El método de ordenación de las imágenes mostradas.",
  "Hay 8 métodos de ordenación para elegir:",
  "La ordenación predeterminada, que corresponde aproximadamente al orden de las imágenes en la página.",
  "Agrupar por tipo de archivo.",
  "Ancho de imagen de menor a mayor.",
  "Ancho de imagen de mayor a menor.",
  "Altura de imagen de menor a mayor.",
  "Altura de imagen de mayor a menor.",
  "Tamaño en píxeles de menor a mayor.",
  "Tamaño en píxeles de mayor a menor."
          ],
          "fr": ["(Affichage) sous-menu",
            "Vous pouvez configurer ici les options suivantes :",
            "Si l’extension s’ouvre dans une fenêtre popup ou en tant que panneau latéral (non disponible sur Firefox). En mode panneau latéral, l’extension reste active même lors du changement d’onglet.",
            "La largeur maximale de l’image dans la zone de résultats (réduisez-la pour afficher plus d’images simultanément dans la zone visible).",
            "Le thème.",
            "La langue de l’interface utilisateur.",
              "La méthode de tri des images affichées.",
  "Il existe 8 méthodes de tri au choix :",
  "Le tri par défaut, qui correspond approximativement à l'ordre des images sur la page.",
  "Regroupement par type de fichier.",
  "Largeur de l'image de la plus petite à la plus grande.",
  "Largeur de l'image de la plus grande à la plus petite.",
  "Hauteur de l'image de la plus petite à la plus grande.",
  "Hauteur de l'image de la plus grande à la plus petite.",
  "Taille en pixels de l'image de la plus petite à la plus grande.",
  "Taille en pixels de l'image de la plus grande à la plus petite."
          ],
          "de": ["(Anzeige) Untermenü",
            "Hier können Sie die folgenden Optionen festlegen:",
            "Ob die Erweiterung in einem Popup oder als Seitenpanel geöffnet wird (nicht verfügbar in Firefox). Im Seitenpanel-Modus bleibt die Erweiterung auch beim Wechseln zwischen Tabs aktiv.",
            "Die maximale Breite des Bildes im Ergebnisbereich (verkleinern, um mehr Bilder gleichzeitig im sichtbaren Bereich anzuzeigen).",
            "Das Thema.",
            "Die Sprache der Benutzeroberfläche.",
             "Die Sortiermethode der angezeigten Bilder.",
  "Es stehen 8 Sortiermethoden zur Auswahl:",
  "Die Standardsortierung, die ungefähr der Reihenfolge der Bilder auf der Seite entspricht.",
  "Gruppierung nach Dateityp.",
  "Bildbreite von klein nach groß.",
  "Bildbreite von groß nach klein.",
  "Bildhöhe von klein nach groß.",
  "Bildhöhe von groß nach klein.",
  "Pixelgröße des Bildes von klein nach groß.",
  "Pixelgröße des Bildes von groß nach klein."
          ],
          "it": ["(Visualizzazione) sottomenu",
            "Qui puoi configurare le seguenti opzioni:",
            "Se l'estensione si apre in un popup o come pannello laterale (non disponibile in Firefox). In modalità pannello laterale, l'estensione rimane attiva anche quando si cambia scheda.",
            "La larghezza massima dell'immagine nell'area dei risultati (riducila per visualizzare più immagini nell'area visibile in qualsiasi momento).",
            "Il tema.",
            "La lingua dell'interfaccia utente.",
              "Il metodo di ordinamento delle immagini visualizzate.",
  "Ci sono 8 metodi di ordinamento tra cui scegliere:",
  "L'ordinamento predefinito, che corrisponde approssimativamente all'ordine delle immagini nella pagina.",
  "Raggruppamento per tipo di file.",
  "Larghezza immagine dalla più piccola alla più grande.",
  "Larghezza immagine dalla più grande alla più piccola.",
  "Altezza immagine dalla più piccola alla più grande.",
  "Altezza immagine dalla più grande alla più piccola.",
  "Dimensione in pixel dell'immagine dalla più piccola alla più grande.",
  "Dimensione in pixel dell'immagine dalla più grande alla più piccola."
          ],
          "hu": ["(Kijelző) almenü",
            "Itt beállíthatja a következő lehetőségeket:",
            "Megnyíljon-e a bővítmény egy felugró ablakban vagy egy oldalsó panelként (Firefoxban nem elérhető). Oldalsó panel módban a bővítmény aktív marad még lapváltáskor is.",
            "A kép maximális szélessége az eredményterületen (csökkentse, hogy egyszerre több kép férjen el a látható területen).",
            "A téma.",
            "A felhasználói felület nyelve.",
            "A megjelenített képek rendezési módja.",
  "8 rendezési módszer közül lehet választani:",
  "Az alapértelmezett rendezés, amely nagyjából megfelel a képek oldalon való sorrendjének.",
  "Csoportosítás fájltípus szerint.",
  "Képszélesség növekvő sorrendben.",
  "Képszélesség csökkenő sorrendben.",
  "Kép magassága növekvő sorrendben.",
  "Kép magassága csökkenő sorrendben.",
  "Kép pixelszáma növekvő sorrendben.",
  "Kép pixelszáma csökkenő sorrendben."
          ],
          "tr": ["(Görüntüleme) alt menü",
            "Burada aşağıdaki ayarları yapabilirsiniz:",
            "Uzantının bir açılır pencerede mi yoksa yan panel olarak mı açılacağını (Firefox'ta mevcut değildir). Yan panel modunda uzantı, sekmeler arasında geçiş yaparken bile aktif kalır.",
            "Sonuç alanındaki görüntünün maksimum genişliği (daha fazla görüntüyü aynı anda görünür alana sığdırmak için küçültün).",
            "Tema.",
            "Kullanıcı arayüzü dili.",
              "Görüntülenen resimlerin sıralama yöntemi.",
  "Seçebileceğiniz 8 sıralama yöntemi vardır:",
  "Sayfadaki resimlerin sırasına kabaca karşılık gelen varsayılan sıralama.",
  "Dosya türüne göre gruplama.",
  "Resim genişliği küçükten büyüğe.",
  "Resim genişliği büyükten küçüğe.",
  "Resim yüksekliği küçükten büyüğe.",
  "Resim yüksekliği büyükten küçüğe.",
  "Piksel boyutu küçükten büyüğe.",
  "Piksel boyutu büyükten küçüğe."
          ],
          "ru": ["(Отображение) подменю",
            "Здесь вы можете настроить следующие параметры:",
            "Будет ли расширение открываться во всплывающем окне или в боковой панели (в Firefox недоступно). В режиме боковой панели расширение остается активным даже при переключении вкладок.",
            "Максимальная ширина изображения в области результатов (уменьшите, чтобы одновременно помещалось больше изображений).",
            "Тема.",
            "Язык интерфейса пользователя.",
              "Метод сортировки отображаемых изображений.",
  "Доступно 8 методов сортировки:",
  "Сортировка по умолчанию, примерно соответствующая порядку изображений на странице.",
  "Группировка по типу файла.",
  "Ширина изображения от меньшего к большему.",
  "Ширина изображения от большего к меньшему.",
  "Высота изображения от меньшего к большему.",
  "Высота изображения от большего к меньшему.",
  "Размер изображения в пикселях от меньшего к большему.",
  "Размер изображения в пикселях от большего к меньшему."
          ],
          "vi": ["(Hiển thị) menu con",
            "Tại đây bạn có thể cài đặt các tùy chọn sau:",
            "Tiện ích sẽ mở dưới dạng cửa sổ bật lên hay bảng bên (không khả dụng trên Firefox). Ở chế độ bảng bên, tiện ích vẫn hoạt động ngay cả khi chuyển đổi giữa các tab.",
            "Chiều rộng tối đa của hình ảnh trong khu vực kết quả (giảm để hiển thị nhiều hình ảnh hơn trong vùng nhìn thấy cùng một lúc).",
            "Chủ đề.",
            "Ngôn ngữ giao diện người dùng.",
              "Phương pháp sắp xếp các hình ảnh hiển thị.",
  "Có 8 phương pháp sắp xếp để lựa chọn:",
  "Sắp xếp mặc định, tương ứng gần đúng với thứ tự hình ảnh trên trang.",
  "Nhóm theo loại tệp.",
  "Chiều rộng ảnh từ nhỏ đến lớn.",
  "Chiều rộng ảnh từ lớn đến nhỏ.",
  "Chiều cao ảnh từ nhỏ đến lớn.",
  "Chiều cao ảnh từ lớn đến nhỏ.",
  "Kích thước điểm ảnh từ nhỏ đến lớn.",
  "Kích thước điểm ảnh từ lớn đến nhỏ."
          ],
          "th": ["(แสดงผล) เมนูย่อย",
            "คุณสามารถตั้งค่าตัวเลือกต่อไปนี้:",
            "ส่วนขยายจะเปิดในป๊อปอัปหรือเป็นแถบด้านข้าง (ใช้ไม่ได้ใน Firefox) ในโหมดแถบด้านข้าง ส่วนขยายจะยังคงทำงานอยู่แม้จะเปลี่ยนแท็บก็ตาม",
            "ความกว้างสูงสุดของรูปภาพในพื้นที่ผลลัพธ์ (ลดขนาดเพื่อให้แสดงรูปภาพได้มากขึ้นในพื้นที่ที่มองเห็นได้ในคราวเดียว)",
            "ธีม.",
            "ภาษาของอินเทอร์เฟซผู้ใช้.",
              "วิธีการจัดเรียงภาพที่แสดงอยู่.",
  "มีวิธีการจัดเรียงให้เลือก 8 แบบ:",
  "การจัดเรียงเริ่มต้น ซึ่งใกล้เคียงกับลำดับของภาพในหน้า",
  "จัดกลุ่มตามประเภทไฟล์",
  "ความกว้างของภาพจากน้อยไปมาก",
  "ความกว้างของภาพจากมากไปน้อย",
  "ความสูงของภาพจากน้อยไปมาก",
  "ความสูงของภาพจากมากไปน้อย",
  "ขนาดพิกเซลของภาพจากน้อยไปมาก",
  "ขนาดพิกเซลของภาพจากมากไปน้อย"
          ],
          "ko": ["(디스플레이) 하위 메뉴",
            "여기에서 다음 옵션을 설정할 수 있습니다:",
            "확장 프로그램이 팝업 창에서 열릴지 아니면 사이드 패널에서 열릴지 설정합니다(Firefox에서는 사용할 수 없음). 사이드 패널 모드에서는 탭을 전환해도 확장 프로그램이 활성 상태로 유지됩니다.",
            "결과 영역에서 이미지의 최대 너비(더 많은 이미지를 한 번에 표시하려면 크기를 줄이세요).",
            "테마.",
            "사용자 인터페이스 언어.",
              "표시된 이미지의 정렬 방법.",
  "선택할 수 있는 정렬 방식은 총 8가지입니다:",
  "기본 정렬 (페이지의 이미지 순서와 대략 일치합니다).",
  "파일 형식별 그룹화.",
  "이미지 너비 오름차순.",
  "이미지 너비 내림차순.",
  "이미지 높이 오름차순.",
  "이미지 높이 내림차순.",
  "픽셀 크기 오름차순.",
  "픽셀 크기 내림차순."
          ],
          "zh_CN": ["(显示) 子菜单",
            "您可以在此处设置以下选项：",
            "扩展程序是以弹出窗口还是侧边面板的方式打开（Firefox 不支持）。在侧边面板模式下，即使切换标签，扩展程序仍然保持活动状态。",
            "结果区域中图像的最大宽度（缩小可以在可见区域内显示更多图像）。",
            "主题。",
            "用户界面语言。",
              "显示图片的排序方式。",
  "共有 8 种排序方式可供选择：",
  "默认排序，大致对应页面中图片的顺序。",
  "按文件类型分组。",
  "按图片宽度从小到大排序。",
  "按图片宽度从大到小排序。",
  "按图片高度从小到大排序。",
  "按图片高度从大到小排序。",
  "按图片像素大小从小到大排序。",
  "按图片像素大小从大到小排序。"
          ],
          "zh_TW": ["(顯示) 子選單",
            "您可以在此處設定以下選項：",
            "擴充功能是以彈出視窗還是側邊面板的方式開啟（Firefox 不支援）。在側邊面板模式下，即使切換標籤頁，擴充功能仍然保持啟動狀態。",
            "結果區域中圖片的最大寬度（縮小可在可見區域內顯示更多圖片）。",
            "主題。",
            "使用者介面語言。",
              "顯示圖片的排序方式。",
  "您可以選擇 8 種排序方式：",
  "預設排序，大致對應頁面上的圖片順序。",
  "依檔案類型分組。",
  "依圖片寬度由小至大排序。",
  "依圖片寬度由大至小排序。",
  "依圖片高度由小至大排序。",
  "依圖片高度由大至小排序。",
  "依圖片像素大小由小至大排序。",
  "依圖片像素大小由大至小排序。"
          ],
          "ja": ["(ディスプレイ) サブメニュー",
            "ここで以下の設定を行えます：",
            "拡張機能をポップアップで開くか、サイドパネルで開くかを設定できます（Firefoxでは利用不可）。サイドパネルモードでは、タブを切り替えても拡張機能がアクティブのままになります。",
            "結果エリアの画像の最大幅（小さくすると、同時に表示できる画像の数が増えます）。",
            "テーマ。",
            "ユーザーインターフェースの言語。",
              "表示される画像の並べ替え方法。",
  "選べる並べ替え方法は8種類あります：",
  "デフォルトの並べ替え（ページ上の画像の順序に大まかに対応）。",
  "ファイルタイプごとにグループ化。",
  "画像の幅が小さい順。",
  "画像の幅が大きい順。",
  "画像の高さが小さい順。",
  "画像の高さが大きい順。",
  "画像のピクセルサイズが小さい順。",
  "画像のピクセルサイズが大きい順。"
          ]
    };
    const lowerBar = {
  "en": [
    "Lower bar buttons",
    "Scroll down and rescan. ",
    "This will attempt to update the results with all the images on the web page, including images that loaded after the extension was initiated. This feature is particularly useful with sites that use infinite scroll or lazy loading.",
    "Tip: Hold Shift and press the button to scroll back to the top of the page.",
    "Opens the folder containing the last downloaded images.",
    "Stops all downloads."
  ],
  "es": [
    "Botones de la barra inferior",
    "Desplazar hacia abajo y volver a escanear. ",
    "Esto intentará actualizar los resultados con todas las imágenes de la página web, incluidas las que se cargaron después de que se iniciara la extensión. Esta función es especialmente útil en sitios que usan desplazamiento infinito o carga diferida.",
    "Consejo: Mantén presionada la tecla Shift y pulsa el botón para volver al inicio de la página.",
    "Abre la carpeta que contiene las últimas imágenes descargadas.",
    "Detiene todas las descargas."
  ],
  "pt": [
    "Botões da barra inferior",
    "Rolar para baixo e reescanear. ",
    "Isso tentará atualizar os resultados com todas as imagens da página da web, incluindo as que foram carregadas após a extensão ter sido iniciada. Esse recurso é particularmente útil em sites que usam rolagem infinita ou carregamento lento.",
    "Dica: Segure a tecla Shift e pressione o botão para voltar ao topo da página.",
    "Abre a pasta que contém as últimas imagens baixadas.",
    "Interrompe todos os downloads."
  ],
  "de": [
    "Schaltflächen der unteren Leiste",
    "Nach unten scrollen und erneut scannen. ",
    "Dies versucht, die Ergebnisse mit allen Bildern auf der Webseite zu aktualisieren, einschließlich der Bilder, die nach dem Start der Erweiterung geladen wurden. Diese Funktion ist besonders nützlich bei Websites mit unendlichem Scrollen oder Lazy Loading.",
    "Tipp: Halte die Umschalttaste gedrückt und drücke die Schaltfläche, um zurück zum Anfang der Seite zu scrollen.",
    "Öffnet den Ordner mit den zuletzt heruntergeladenen Bildern.",
    "Beendet alle Downloads."
  ],
  "it": [
    "Pulsanti della barra inferiore",
    "Scorri verso il basso e riesegui la scansione. ",
    "Questo tenterà di aggiornare i risultati con tutte le immagini nella pagina web, comprese quelle caricate dopo l’avvio dell’estensione. Questa funzione è particolarmente utile con siti che utilizzano lo scorrimento infinito o il caricamento differito.",
    "Suggerimento: Tieni premuto Shift e premi il pulsante per tornare all’inizio della pagina.",
    "Apre la cartella contenente le ultime immagini scaricate.",
    "Interrompe tutti i download."
  ],
  "hu": [
    "Alsó sáv gombjai",
    "Görgetés lefelé és újraszkennelés. ",
    "Ez megpróbálja frissíteni az eredményeket az összes képpel a weboldalon, beleértve azokat is, amelyek a bővítmény indítása után töltődtek be. Ez a funkció különösen hasznos végtelen görgetést vagy lusta betöltést használó webhelyeken.",
    "Tipp: Tartsd lenyomva a Shift billentyűt, és nyomd meg a gombot az oldal tetejére való visszagörgetéshez.",
    "Megnyitja a mappát, amely az utoljára letöltött képeket tartalmazza.",
    "Leállítja az összes letöltést."
  ],
  "fr": [
    "Boutons de la barre inférieure",
    "Faire défiler vers le bas et rescanner. ",
    "Cela tentera de mettre à jour les résultats avec toutes les images de la page web, y compris celles chargées après le démarrage de l’extension. Cette fonctionnalité est particulièrement utile sur les sites utilisant le défilement infini ou le chargement différé.",
    "Astuce : Maintenez la touche Maj enfoncée et appuyez sur le bouton pour revenir en haut de la page.",
    "Ouvre le dossier contenant les dernières images téléchargées.",
    "Arrête tous les téléchargements."
  ],
  "tr": [
    "Alt çubuk düğmeleri",
    "Aşağı kaydır ve yeniden tara. ",
    "Bu, web sayfasındaki tüm resimlerle sonuçları güncellemeye çalışacaktır, uzantı başlatıldıktan sonra yüklenenler de dahil. Bu özellik özellikle sonsuz kaydırma veya tembel yükleme kullanan sitelerde faydalıdır.",
    "İpucu: Sayfanın en üstüne dönmek için Shift tuşunu basılı tutup düğmeye basın.",
    "Son indirilen görsellerin bulunduğu klasörü açar.",
    "Tüm indirmeleri durdurur."
  ],
  "ru": [
    "Кнопки нижней панели",
    "Прокрутить вниз и пересканировать. ",
    "Будет предпринята попытка обновить результаты со всеми изображениями на веб-странице, включая изображения, загруженные после запуска расширения. Эта функция особенно полезна на сайтах с бесконечной прокруткой или отложенной загрузкой.",
    "Совет: Удерживайте Shift и нажмите кнопку, чтобы вернуться в начало страницы.",
    "Открывает папку с последними загруженными изображениями.",
    "Останавливает все загрузки."
  ],
  "he": [
    "כפתורי השורה התחתונה",
    "גלול למטה וסרוק מחדש. ",
    "פעולה זו תנסה לעדכן את התוצאות עם כל התמונות שבעמוד, כולל תמונות שנטענו לאחר שההרחבה הופעלה. תכונה זו שימושית במיוחד באתרים המשתמשים בגלילה אינסופית או בטעינה מתעכבת.",
    "טיפ: החזק את מקש Shift ולחץ על הכפתור כדי לגלול חזרה לראש הדף.",
    "פותח את התיקייה שמכילה את התמונות שהורדו לאחרונה.",
    "עוצר את כל ההורדות."
  ],
  "th": [
    "ปุ่มแถบด้านล่าง",
    "เลื่อนลงและสแกนใหม่. ",
    "ระบบจะพยายามอัปเดตผลลัพธ์ด้วยภาพทั้งหมดในหน้าเว็บ รวมถึงภาพที่โหลดหลังจากส่วนขยายถูกเริ่มทำงาน ฟีเจอร์นี้มีประโยชน์อย่างยิ่งกับเว็บไซต์ที่ใช้การเลื่อนแบบไม่สิ้นสุดหรือการโหลดแบบ Lazy.",
    "เคล็ดลับ: กดปุ่ม Shift ค้างไว้แล้วกดปุ่มเพื่อเลื่อนไปยังด้านบนสุดของหน้า.",
    "เปิดโฟลเดอร์ที่มีภาพที่ดาวน์โหลดล่าสุด.",
    "หยุดการดาวน์โหลดทั้งหมด."
  ],
  "ko": [
    "하단 표시줄 버튼",
    "아래로 스크롤 후 다시 스캔. ",
    "이 기능은 웹 페이지의 모든 이미지를 포함하도록 결과를 업데이트하려고 시도합니다. 여기에는 확장 프로그램이 시작된 후 로드된 이미지도 포함됩니다. 이 기능은 무한 스크롤이나 지연 로딩을 사용하는 사이트에서 특히 유용합니다.",
    "팁: Shift 키를 누른 상태에서 버튼을 누르면 페이지 맨 위로 스크롤됩니다.",
    "마지막으로 다운로드한 이미지가 포함된 폴더를 엽니다.",
    "모든 다운로드를 중지합니다."
  ],
  "ja": [
    "下部バーのボタン",
    "下にスクロールして再スキャン。 ",
    "これにより、拡張機能が開始された後に読み込まれた画像を含め、ウェブページ上のすべての画像で結果を更新しようとします。この機能は、無限スクロールや遅延読み込みを使用しているサイトで特に便利です。",
    "ヒント: Shift キーを押しながらボタンを押すと、ページの一番上までスクロールできます。",
    "最後にダウンロードした画像を含むフォルダを開きます。",
    "すべてのダウンロードを停止します。"
  ],
  "vi": [
    "Các nút trên thanh dưới",
    "Cuộn xuống và quét lại. ",
    "Thao tác này sẽ cố gắng cập nhật kết quả với tất cả hình ảnh trên trang web, bao gồm cả những hình ảnh được tải sau khi tiện ích được khởi chạy. Tính năng này đặc biệt hữu ích với các trang sử dụng cuộn vô hạn hoặc tải lười.",
    "Mẹo: Giữ phím Shift và nhấn nút để cuộn về đầu trang.",
    "Mở thư mục chứa các hình ảnh vừa tải xuống.",
    "Dừng tất cả quá trình tải xuống."
  ],
  "zh_CN": [
    "底部栏按钮",
    "向下滚动并重新扫描。 ",
    "这将尝试使用网页上的所有图片更新结果，包括在扩展启动后加载的图片。此功能对使用无限滚动或延迟加载的网站特别有用。",
    "提示：按住 Shift 键并点击按钮可滚动回页面顶部。",
    "打开包含最近下载图片的文件夹。",
    "停止所有下载。"
  ],
  "zh_TW": [
    "底部列按鈕",
    "向下捲動並重新掃描。 ",
    "這將嘗試使用網頁上的所有圖片更新結果，包括在擴充功能啟動後載入的圖片。此功能對使用無限捲動或延遲載入的網站特別有用。",
    "提示：按住 Shift 鍵並按下按鈕即可回到頁面頂部。",
    "開啟包含最近下載圖片的資料夾。",
    "停止所有下載。"
  ]
};
    const Troubleshooting = {
      "en":["Troubleshooting", "Extension failed to capture the images",
        "Refresh the page, wait until the images are loaded on the page, then open the extension. If it still fails, it is possible your filter is set too strict or that the site employs techniques that prevent image detection. See if you can capture images on a different site.",
        "Can't set the folder name or file name prefix",
        "Make sure the circle next to the text field is selected. If it is, the issue might be caused by a conflict with another extension installed after Image Downloader. Try disabling any extensions that were added later.",
        "Browser prompts you to manually save every image","Follow the","Check browser settings","section instructions.","Unable to use in private mode",
        "Browsers require users to explicitly allow extensions to work in private (incognito) mode. Here are Instructions on how to set the extension in private mode for:",
        "If you encounter an issue, you can always","contact","us for help."],
        "he": [
  "פתרון בעיות",
  "ההרחבה נכשלה בלכידת התמונות",
  "רענן את הדף, המתן לטעינת כל התמונות ואז פתח את ההרחבה. אם עדיין לא עובד, ייתכן שהמסנן שלך מחמיר מדי או שהאתר משתמש בטכניקות שמונעות זיהוי תמונות. נסה באתר אחר.",
  "לא ניתן להגדיר שם תיקייה או קידומת לקובץ",
  "ודא שהעיגול שליד שדה הטקסט מסומן. אם כן, ייתכן שהבעיה נגרמת עקב התנגשות עם הרחבה אחרת שהותקנה אחרי מוריד התמונות. נסה להשבית הרחבות שהותקנו מאוחר יותר.",
  "הדפדפן מבקש לשמור כל תמונה באופן ידני",
  "עקוב אחרי הוראות הסעיף",
  "בדוק הגדרות דפדפן",
  ".",
  "לא ניתן להשתמש במצב גלישה פרטית",
  "דפדפנים דורשים הרשאה מפורשת להפעלת הרחבות במצב פרטי (אינקוגניטו). הנה הוראות להפעלת ההרחבה במצב פרטי עבור:",
  "אם נתקלת בבעיה, תמיד אפשר",
  "ליצור קשר",
  "עם הצוות שלנו לעזרה."
],
"pt": [
  "Solução de problemas",
  "A extensão falhou ao capturar as imagens",
  "Atualize a página, aguarde o carregamento das imagens e abra a extensão. Se ainda falhar, pode ser que o filtro esteja muito restritivo ou que o site use técnicas que impedem a detecção de imagens. Tente em outro site.",
  "Não é possível definir o nome da pasta ou o prefixo do arquivo",
  "Certifique-se de que o círculo ao lado do campo de texto esteja selecionado. Se estiver, o problema pode ser causado por um conflito com outra extensão instalada após o baixador de imagens. Tente desativar as extensões instaladas posteriormente.",
  "O navegador solicita salvar manualmente cada imagem",
  "Siga as",
  "Configurações do navegador",
  "instruções da seção.",
  "Não é possível usar no modo anônimo",
  "Os navegadores exigem permissão explícita para que extensões funcionem no modo privado (anônimo). Veja como ativar a extensão nesse modo para:",
  "Se você encontrar algum problema, pode sempre",
  "entrar em contato",
  "conosco para obter ajuda."
],
"es": [
  "Solución de problemas",
  "La extensión no pudo capturar las imágenes",
  "Actualiza la página, espera a que se carguen las imágenes y luego abre la extensión. Si aún falla, puede que el filtro sea demasiado estricto o que el sitio use técnicas que impiden detectar imágenes. Prueba en otro sitio.",
  "No se puede establecer el nombre de la carpeta o el prefijo del archivo",
  "Asegúrate de que el círculo junto al campo de texto esté seleccionado. Si lo está, el problema podría deberse a un conflicto con otra extensión instalada después del descargador de imágenes. Intenta desactivar las extensiones instaladas posteriormente.",
  "El navegador te pide guardar cada imagen manualmente",
  "Sigue las",
  "Configuración del navegador",
  "instrucciones de la sección.",
  "No se puede usar en modo incógnito",
  "Los navegadores requieren que los usuarios permitan explícitamente que las extensiones funcionen en modo incógnito. Aquí tienes las instrucciones para activar la extensión en ese modo para:",
  "Si tienes algún problema, siempre puedes",
  "contactar",
  "con nosotros para obtener ayuda."
],
"fr": [
  "Dépannage",
  "L’extension n’a pas pu capturer les images",
  "Rafraîchissez la page, attendez que les images se chargent, puis ouvrez l’extension. Si cela échoue, il est possible que votre filtre soit trop strict ou que le site utilise des techniques empêchant la détection des images. Essayez sur un autre site.",
  "Impossible de définir le nom du dossier ou le préfixe du fichier",
  "Assurez-vous que le cercle à côté du champ de texte est sélectionné. Si c’est le cas, le problème peut être dû à un conflit avec une autre extension installée après le téléchargeur d’images. Essayez de désactiver les extensions installées par la suite.",
  "Le navigateur vous demande d’enregistrer chaque image manuellement",
  "Suivez les",
  "Paramètres du navigateur",
  "instructions de la section.",
  "Impossible d’utiliser en mode privé",
  "Les navigateurs exigent une autorisation explicite pour permettre aux extensions de fonctionner en mode privé (navigation privée). Voici comment activer l’extension en mode privé pour :",
  "Si vous rencontrez un problème, vous pouvez toujours",
  "nous contacter",
  "pour obtenir de l’aide."
],
"de": [
  "Fehlerbehebung",
  "Die Erweiterung konnte die Bilder nicht erfassen",
  "Laden Sie die Seite neu, warten Sie, bis die Bilder geladen sind, und öffnen Sie dann die Erweiterung. Falls es weiterhin nicht funktioniert, ist der Filter möglicherweise zu streng oder die Website nutzt Techniken, die die Erkennung von Bildern verhindern. Versuchen Sie es auf einer anderen Seite.",
  "Ordnername oder Dateipräfix kann nicht gesetzt werden",
  "Stellen Sie sicher, dass der Kreis neben dem Textfeld ausgewählt ist. Falls ja, könnte das Problem durch einen Konflikt mit einer anderen Erweiterung verursacht werden, die nach dem Bild-Downloader installiert wurde. Versuchen Sie, später installierte Erweiterungen zu deaktivieren.",
  "Der Browser fordert zum manuellen Speichern jeder einzelnen Bilddatei auf",
  "Befolgen Sie die",
  "Browser-Einstellungen",
  "Abschnittsanweisungen.",
  "Im privaten Modus nicht nutzbar",
  "Browser erfordern eine ausdrückliche Erlaubnis, damit Erweiterungen im privaten Modus funktionieren. So aktivieren Sie die Erweiterung für:",
  "Wenn ein Problem auftritt, können Sie uns jederzeit",
  "kontaktieren",
  "für Hilfe."
],
"it": [
  "Risoluzione dei problemi",
  "L'estensione non è riuscita a catturare le immagini",
  "Ricarica la pagina, attendi il caricamento delle immagini, quindi apri l'estensione. Se il problema persiste, il filtro potrebbe essere troppo restrittivo o il sito potrebbe usare tecniche per impedire la rilevazione delle immagini. Prova su un altro sito.",
  "Impossibile impostare il nome della cartella o il prefisso del file",
  "Assicurati che il cerchio accanto al campo di testo sia selezionato. Se lo è, il problema potrebbe essere causato da un conflitto con un’altra estensione installata dopo il downloader di immagini. Prova a disabilitare le estensioni installate successivamente.",
  "Il browser ti chiede di salvare manualmente ogni immagine",
  "Segui le",
  "Impostazioni del browser",
  "istruzioni della sezione.",
  "Impossibile usare in modalità privata",
  "I browser richiedono un'autorizzazione esplicita per consentire alle estensioni di funzionare in modalità privata (in incognito). Ecco come impostare l'estensione in modalità privata per:",
  "Se riscontri un problema, puoi sempre",
  "contattarci",
  "per ricevere aiuto."
],
"hu": [
  "Hibaelhárítás",
  "A kiterjesztés nem tudta rögzíteni a képeket",
  "Frissítse az oldalt, várja meg, amíg a képek betöltődnek, majd nyissa meg a kiterjesztést. Ha továbbra sem működik, lehet, hogy a szűrő túl szigorú, vagy az oldal olyan technikákat alkalmaz, amelyek megakadályozzák a képek észlelését. Próbálja meg egy másik oldalon.",
  "Nem lehet beállítani a mappa nevét vagy a fájlnév előtagját",
  "Győződj meg róla, hogy a szövegmező melletti kör ki van jelölve. Ha igen, a problémát egy másik bővítménnyel való ütközés okozhatja, amelyet a kép-letöltő után telepítettek. Próbáld meg letiltani a később telepített bővítményeket.",
  "A böngésző minden képet manuálisan akar elmenteni",
  "Kövesse a",
  "Böngésző beállításait",
  "szakasz utasításait.",
  "Nem használható privát módban",
  "A böngészők külön engedélyt igényelnek a kiterjesztések privát (inkognitó) módban való használatához. Itt található, hogyan lehet ezt beállítani a következőhöz:",
  "Ha problémába ütközik, mindig",
  "fordulhat hozzánk",
  "segítségért."
],
"tr": [
  "Sorun Giderme",
  "Uzantı görüntüleri yakalayamadı",
  "Sayfayı yenileyin, görüntülerin tamamen yüklendiğinden emin olun, ardından uzantıyı açın. Hâlâ çalışmazsa, filtre çok katı olabilir veya site, görüntü tespitini engelleyen teknikler kullanıyor olabilir. Başka bir sitede deneyin.",
  "Klasör adı veya dosya adı ön eki ayarlanamıyor",
"Metin alanının yanındaki dairenin seçili olduğundan emin olun. Eğer seçiliyse, sorun görüntü indiriciden sonra yüklenen başka bir uzantıyla yaşanan çakışmadan kaynaklanıyor olabilir. Daha sonra yüklenen uzantıları devre dışı bırakmayı deneyin.",
  "Tarayıcı her resmi manuel olarak kaydetmenizi istiyor",
  "Şunu takip edin:",
  "Tarayıcı ayarları",
  "bölüm talimatları.",
  "Gizli modda kullanılamıyor",
  "Tarayıcılar, uzantıların gizli (incognito) modda çalışmasına açıkça izin verilmesini gerektirir. Aşağıda, gizli modda uzantıyı etkinleştirme talimatları yer almaktadır:",
  "Bir sorunla karşılaşırsanız her zaman",
  "bizimle iletişime geçebilir",
  "yardım alabilirsiniz."
],
"ru": [
  "Устранение неполадок",
  "Расширению не удалось захватить изображения",
  "Обновите страницу, дождитесь загрузки изображений, затем откройте расширение. Если всё ещё не работает, возможно, фильтр слишком строгий или сайт использует технологии, препятствующие обнаружению изображений. Попробуйте на другом сайте.",
  "Невозможно задать имя папки или префикс имени файла",
"Убедитесь, что кружок рядом с текстовым полем выбран. Если да, проблема может быть вызвана конфликтом с другим расширением, установленным после загрузчика изображений. Попробуйте отключить расширения, установленные позже.",
  "Браузер предлагает сохранять каждое изображение вручную",
  "Следуйте",
  "Настройкам браузера",
  "инструкциям раздела.",
  "Невозможно использовать в приватном режиме",
  "Браузеры требуют явного разрешения для работы расширений в приватном (инкогнито) режиме. Вот как включить расширение в приватном режиме для:",
  "Если возникла проблема, вы всегда можете",
  "связаться с нами",
  "для получения помощи."
],
"th": [
  "การแก้ไขปัญหา",
  "ส่วนขยายไม่สามารถจับภาพได้",
  "รีเฟรชหน้า รอให้โหลดรูปภาพทั้งหมด แล้วเปิดส่วนขยายอีกครั้ง หากยังไม่ได้ อาจเป็นเพราะตัวกรองของคุณเข้มงวดเกินไป หรือเว็บไซต์ใช้เทคนิคที่ป้องกันไม่ให้ตรวจจับรูปภาพ ลองกับเว็บไซต์อื่น",
  "ไม่สามารถตั้งชื่อโฟลเดอร์หรือตั้งคำนำหน้าชื่อไฟล์ได้",
  "ตรวจสอบให้แน่ใจว่าได้เลือกวงกลมที่อยู่ถัดจากช่องข้อความ หากเลือกแล้ว ปัญหาอาจเกิดจากความขัดแย้งกับส่วนขยายอื่นที่ติดตั้งหลังจากตัวดาวน์โหลดรูปภาพ ลองปิดการทำงานของส่วนขยายที่ติดตั้งภายหลัง",
  "เบราว์เซอร์ขอให้บันทึกภาพทีละภาพด้วยตนเอง",
  "ทำตาม",
  "การตั้งค่าเบราว์เซอร์",
  "คำแนะนำในส่วนนี้",
  "ไม่สามารถใช้ในโหมดส่วนตัวได้",
  "เบราว์เซอร์ต้องการให้ผู้ใช้อนุญาตอย่างชัดเจนเพื่อให้ส่วนขยายทำงานในโหมดส่วนตัว (ไม่ระบุตัวตน) นี่คือวิธีตั้งค่าส่วนขยายให้ทำงานในโหมดส่วนตัว:",
  "หากคุณพบปัญหา คุณสามารถ",
  "ติดต่อ",
  "เราเพื่อขอความช่วยเหลือได้เสมอ"
],
"vi": [
  "Khắc phục sự cố",
  "Tiện ích không thể bắt được hình ảnh",
  "Làm mới trang, đợi cho các hình ảnh tải xong rồi mở tiện ích. Nếu vẫn không được, có thể bộ lọc của bạn quá nghiêm ngặt hoặc trang web sử dụng kỹ thuật ngăn chặn việc phát hiện hình ảnh. Thử trên một trang khác.",
  "Không thể đặt tên thư mục hoặc tiền tố tên tệp",
  "Đảm bảo rằng vòng tròn bên cạnh trường văn bản được chọn. Nếu đúng, sự cố có thể do xung đột với tiện ích mở rộng khác được cài đặt sau trình tải xuống hình ảnh. Hãy thử tắt các tiện ích mở rộng được thêm vào sau đó.",
  "Trình duyệt yêu cầu lưu từng ảnh thủ công",
  "Làm theo",
  "Cài đặt trình duyệt",
  "hướng dẫn trong phần.",
  "Không thể sử dụng trong chế độ riêng tư",
  "Trình duyệt yêu cầu người dùng cho phép rõ ràng để tiện ích hoạt động trong chế độ riêng tư (ẩn danh). Dưới đây là cách thiết lập tiện ích cho chế độ riêng tư:",
  "Nếu bạn gặp sự cố, bạn luôn có thể",
  "liên hệ",
  "với chúng tôi để được giúp đỡ."
],
"ko": [
  "문제 해결",
  "확장 프로그램이 이미지를 캡처하지 못했습니다",
  "페이지를 새로고침하고 이미지가 모두 로드될 때까지 기다린 다음 확장 프로그램을 열어보세요. 여전히 실패한다면 필터가 너무 엄격하거나 사이트에서 이미지 감지를 방지하는 기술을 사용할 수 있습니다. 다른 사이트에서 시도해보세요.",
  "폴더 이름 또는 파일 이름 접두사를 설정할 수 없습니다",
  "텍스트 필드 옆의 원이 선택되어 있는지 확인하세요. 선택되어 있다면, 문제는 이미지 다운로더 이후에 설치된 다른 확장 프로그램과의 충돌로 인해 발생했을 수 있습니다. 나중에 추가된 확장 프로그램을 비활성화해 보세요.",
  "브라우저가 모든 이미지를 수동으로 저장하도록 요청합니다",
  "다음을 따르세요:",
  "브라우저 설정",
  "섹션 지침.",
  "시크릿 모드에서는 사용할 수 없습니다",
  "브라우저는 시크릿 모드(비공개 모드)에서 확장 기능이 작동하도록 명시적인 허용이 필요합니다. 다음은 시크릿 모드에서 확장 기능을 설정하는 방법입니다:",
  "문제가 발생하면 언제든지",
  "문의해",
  "주세요 도움을 받으실 수 있습니다."
],
"zh_CN": [
  "故障排除",
  "扩展程序未能捕获图像",
  "请刷新页面，等待所有图像加载完成后再打开扩展程序。如果仍然失败，可能是您的过滤器设置过于严格，或者该网站使用了阻止图像检测的技术。请尝试在其他网站上测试。",
  "无法设置文件夹名称或文件名前缀",
  "请确保选中了文本字段旁边的圆圈。如果是这样，问题可能是由在安装图片下载器之后安装的其他扩展程序冲突引起的。尝试禁用后来添加的扩展程序。",
  "浏览器提示您手动保存每个图像",
  "请按照",
  "浏览器设置",
  "部分的说明进行操作。",
  "无法在隐私模式下使用",
  "浏览器要求用户显式允许扩展程序在隐私（无痕）模式下运行。以下是为以下浏览器启用扩展程序隐私模式的方法：",
  "如果您遇到问题，可以随时",
  "联系",
  "我们以获取帮助。"
],
"zh_TW": [
  "疑難排解",
  "擴充功能無法擷取圖片",
  "請重新整理頁面，等圖片載入完成後再開啟擴充功能。如果仍然失敗，可能是您的過濾器設得太嚴格，或網站使用了防止圖片被偵測的技術。請嘗試在其他網站使用。",
  "無法設定資料夾名稱或檔名前綴",
  "請確保已選取文字欄位旁邊的圓圈。如果是這樣，問題可能是由在安裝圖片下載器之後安裝的其他擴充功能衝突所造成的。嘗試停用後來新增的擴充功能。",
  "瀏覽器要求您手動儲存每張圖片",
  "請依照",
  "瀏覽器設定",
  "區段的指示進行操作。",
  "無法在隱私模式下使用",
  "瀏覽器需要使用者明確允許擴充功能在隱私（無痕）模式中運行。以下是為這些瀏覽器啟用隱私模式的操作說明：",
  "如果您遇到任何問題，隨時都可以",
  "聯絡我們",
  "以取得協助。"
],
"ja": [
  "トラブルシューティング",
  "拡張機能が画像を取得できませんでした",
  "ページを更新して、すべての画像が読み込まれるのを待ってから拡張機能を開いてください。それでも失敗する場合、フィルターが厳しすぎるか、サイトが画像検出を妨げる技術を使用している可能性があります。別のサイトで試してみてください。",
  "フォルダー名またはファイル名の接頭辞を設定できません",
  "テキストフィールドの横にある丸が選択されていることを確認してください。選択されている場合、問題は画像ダウンローダーの後にインストールされた別の拡張機能との競合が原因である可能性があります。後から追加された拡張機能を無効にしてみてください。",
  "ブラウザが画像を手動で保存するよう求めてきます",
  "次に従ってください：",
  "ブラウザの設定",
  "セクションの指示に従ってください。",
  "プライベートモードでは使用できません",
  "ブラウザでは、拡張機能がプライベート（シークレット）モードで動作するには明示的な許可が必要です。以下は、各ブラウザでの設定手順です：",
  "問題が発生した場合は、いつでも",
  "お問い合わせ",
  "ください。"
]
    }
    const {language} = useParams();
    let lang = language;
    document.title = "Image downloader";
    const locals = ['pt','es','fr','de','it','hu','tr','ru','he','vi','th','ko','zh_CN','zh_TW','ja'];                
    if(!locals.includes(lang)){
      lang='en';
    }
    let langT = 'en';
    if(lang == 'ja'){
      langT = lang;
    }
    const getCode = "/image_downloader-get_code/"+lang;
    const hash = useHash();
  useEffect(() => {
    const section = hash.replace("#", "");
    if (section) scrollToSection(section);
  }, [hash]);
    return(
        <div style={{direction: lang != 'he' ? 'ltr' : 'rtl'}}>
        <Header title="Image Downloader" x="20"/>
        <Lang />
        <div id="i-d-quick-nav">
                <b>
                    <ul style={{listStyleType:'none', margin: '0 0 0 0', padding: '0 0 0 0'}}>
                        <li><a href="#limitations">{limition[lang][0]}</a></li>
                        <li><a href="#check-settings">{checkSettings[lang][0]}</a></li>
                        <li><a href="#pin-extension-icon">{general[lang][0]}</a></li>
                        <li><a href="#tutorial">{userGuideOpening[lang][0]}</a></li>
                        <li><a href="#troubleshooting">{Troubleshooting[lang][0]}</a></li>
                    </ul>
                </b>
            </div>
        <div className="article">
        <p><b>{description[lang][0]}</b></p>
        <p>
{description[lang][1]}<br/>
{description[lang][2]}<br/>
{description[lang][3]}</p>
<p>
<b>{description[lang][4]}</b>
<br/>
<ul>
    <li>{description[lang][5]}</li>
    <li>{description[lang][6]}</li>
    <li>{description[lang][7]}</li>
    <li>{description[lang][8]}</li>
    <li>{description[lang][9]}</li>
    <li>{description[lang][10]}</li>
    </ul></p>
    {description[lang][11]}<a href="https://chromewebstore.google.com/detail/image-downloader-save-all/fpelahbljekknahkcaegamhcndkfpfnc" className="button-link">Chrome</a> &nbsp;
 <a href="https://microsoftedge.microsoft.com/addons/detail/image-downloader-save-a/flbolonkboilcbnohjlchlfgdalomdpl" className="button-link">Edge</a>  &nbsp;
 <a href="https://addons.mozilla.org/en-US/firefox/addon/image-downloader-for-firefox/?utm_source=addons.mozilla.org&utm_medium=referral&utm_content=search" className="button-link">Firefox</a>
        </div>
<div id="limitations" className="main-title">
    <p>{limition[lang][0]}</p>
</div>
<div className="article">
    <ul>
        <li>{limition[lang][1]}</li>
        <li>{limition[lang][2]}</li>
        <li>{limition[lang][3]}</li>
        <li>{limition[lang][4]}</li>
        <li>{limition[lang][5]}</li>
    </ul>
</div>
            <div id="check-settings" className="main-title"><p>{checkSettings[lang][0]}</p></div>
        <div className="article">
            {checkSettings[lang][1]}<b>Chrome</b>{checkSettings[lang][2]}<b>Edge</b>{checkSettings[lang][3]}<b>{checkSettings[lang][4]}</b>{checkSettings[lang][5]}<b>{checkSettings[lang][6]}</b>{checkSettings[lang][7]}<b>{checkSettings[lang][8]}</b>{checkSettings[lang][9]}
            <br/><img id="i-d-check" src={"../assets/image downloader/"+lang+"/check-browser.png"} style={{marginTop:"24px"}}/><br/>
            {checkSettings[lang][10]}<b>Firefox</b>{checkSettings[lang][11]}<b>{checkSettings[lang][12]}</b>{checkSettings[lang][13]}<b>{checkSettings[lang][14]}</b>{checkSettings[lang][15]}<b>{checkSettings[lang][16]}</b>{checkSettings[lang][17]}
        </div>
        <PinExtension lang={lang} />
        <div id="tutorial" className="main-title"><p> {userGuideOpening[lang][0]}</p></div>
        <div className="article">
        <p>
        {userGuideOpening[lang][1]}
        </p>
        <div style={{position: "relative",display: "inline-block"}}>
        <img src={"../assets/image downloader/"+lang+"/image downloader frame.png"}style={{display: "block"}} />
        <img src={"../assets/image downloader/image downloader inner.webP"} style={{position: "absolute",top: "86px",insetInlineEnd: "28px"}} />
        </div>
        <br />
        {userGuideOpening[lang][2]}
        <p>
        {userGuideOpening[lang][3]} <img src="../assets/download-selected.png" width="20px" /> {userGuideOpening[lang][4]}&nbsp; 
        {userGuideOpening[lang][5]}<img src="../assets/download-all-icon.svg" width="24px" style={{verticalAlign: "text-bottom"}}/>{userGuideOpening[lang][6]}&nbsp; 
        {userGuideOpening[lang][7]}<img src="../assets/save-icon.svg" width="24px" style={{verticalAlign: "text-bottom"}} />{userGuideOpening[lang][8]}&nbsp;
        {userGuideOpening[lang][9]}<img src="../assets/more-icon.svg" width="24px" style={{verticalAlign: "text-bottom"}} />{userGuideOpening[lang][10]}
        </p>
        <p>
        {userGuideOpening[lang][11]} <img src="../assets/new-tab.svg" width="20px" /> {userGuideOpening[lang][12]} <img src="../assets/remove-background.svg" width="20px" />&nbsp;
        {userGuideOpening[lang][13]} 
        </p>
        {userGuideOpening[lang][14]}
    <p><h3 className='submenu'>{size[lang][0]}</h3></p> {size[lang][1]}<b>{size[lang][2]}</b>{size[lang][3]}<b>{size[lang][4]}</b>{size[lang][5]}<b>{size[lang][6]}</b>{size[lang][7]}<b>{size[lang][8]}</b>{size[lang][9]}<b>{size[lang][10]}</b>{size[lang][11]}<br/>
            <p><h3 className='submenu'>{typeLayout[lang][0]}</h3></p>{typeLayout[lang][1]}
            <p><h3 className='submenu'>{typeLayout[lang][2]}</h3></p>{typeLayout[lang][3]}
            <p><h3 className='submenu'>{advanced[lang][0]}</h3></p>
             <p>{advanced[lang][1]}<img src="../assets/trash.svg" width="20px" />{advanced[lang][2]}
             {advanced[lang][3]}
             </p><p> {advanced[lang][4]}</p>
                          <p><h3 className='submenu' id="save-config"><img src="../assets/save config.svg" width="30px" /> {save[lang][0]}</h3>
             </p>
             {save[lang][1]}
             <p>{save[lang][2]}<img src="../assets/save-path.svg" width="28px" style={{verticalAlign: "middle"}}/>.</p> 

                    <p>{save[lang][3]} <img src="../assets/convarte.svg" width="36px" />
                    {save[lang][4]}
                </p>
                <p><h3 className='submenu'><img src="../assets/display.svg" width="24px" /> {display[lang][0]}</h3></p> {display[lang][1]}<br/><ul>
                <li>
                <img src="../assets/popup.svg" width="32px" />&nbsp;<img src="../assets/side-panel.svg" width="32px" />&nbsp;{display[lang][2]}                  
                </li>
                    <li>
                    <img src="../assets/result-width.svg" width="32px" />&nbsp;{display[lang][3]}
                    </li>
                    <li>
                        <img src="../assets/sort.svg" width="24px" />&nbsp;{display[lang][6]}<br/>{display[lang][7]}<br/><ul>
                          <li><img src="../assets/sort-default.svg" width="24px" /> {display[lang][8]}</li>
                          <li><img src="../assets/sort-type.svg" width="24px" /> {display[lang][9]}</li>
                          <li><img src="../assets/sort-width-s-l.svg" width="24px" /> {display[lang][10]}</li>
                          <li><img src="../assets/sort-width-l-s.svg" width="24px" /> {display[lang][11]}</li>
                          <li><img src="../assets/sort-height-s-l.svg" width="24px" /> {display[lang][12]}</li>
                          <li><img src="../assets/sort-height-l-s.svg" width="24px" /> {display[lang][13]}</li>
                          <li><img src="../assets/sort-size-s-l.svg" width="24px" /> {display[lang][14]}</li>
                          <li><img src="../assets/sort-size-l-s.svg" width="24px" /> {display[lang][15]}</li></ul>
                    </li>
                    <li>
                        <img src="../assets/theme.png"/>&nbsp;&nbsp;{display[lang][4]}
                    </li>
                    <li>
                        <img src="../assets/language.svg" width="32px" />&nbsp;{display[lang][5]}
                    </li>
                    </ul>
                    <p><h3 className='submenu'>{lowerBar[lang][0]}</h3></p> 
                    <ul>
                      <li><img src="../assets/scroll-down-and-scan.svg" width="24px" />&nbsp;{lowerBar[lang][1]}{lowerBar[lang][2]}<br/>{lowerBar[lang][3]}
                      <iframe width="780" height="473" src="https://www.youtube.com/embed/FgTbm-Rh_fY?si=ZznW8NOwdMSXQ_mf" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                      </li>
                      <li><img src="../assets/open-folder.svg" width="24px" />&nbsp;{lowerBar[lang][4]}</li>
                      <li><img src="../assets/stop-downloads.svg" width="24px" />&nbsp;{lowerBar[lang][5]}</li>
                    </ul>
        </div>
        <div id="troubleshooting" className="main-title">
    <p>{Troubleshooting[lang][0]}</p>
</div>

<div className="article">
    <div>
        <h3 className='submenu'>{Troubleshooting[lang][1]}</h3>
        <p>
            {Troubleshooting[lang][2]}
        </p>
    </div>
    
    <div>
        <h3 className='submenu'>{Troubleshooting[lang][3]}</h3>
        <p>
        {Troubleshooting[lang][4]}
        </p>
    </div>

    <div>
        <h3 className='submenu'>{Troubleshooting[lang][5]}</h3>
        <p>
            {Troubleshooting[lang][6]} <Link to="#check-settings"><span className="button-link">{Troubleshooting[lang][7]}</span></Link> {Troubleshooting[lang][8]}
        </p>
    </div>

    <div>
        <h3 className='submenu'>{Troubleshooting[lang][9]}</h3>
        <p>
            {Troubleshooting[lang][10]}&nbsp; 
            <a href="https://support.google.com/chrome/a/answer/13130396?hl=en" className="button-link">Chrome</a>&nbsp;
            <a href="https://www.tenforums.com/tutorials/166235-allow-extensions-inprivate-browsing-microsoft-edge-chromium.html" className="button-link">Edge</a>&nbsp;
            <a href="https://support.mozilla.org/en-US/kb/extensions-private-browsing" className="button-link">Firefox</a>
        </p>
    </div>

    <div>
        <h3><b>{Troubleshooting[lang][11]} <Link to="/contact/en"><span className="button-link">{Troubleshooting[lang][12]}</span></Link> {Troubleshooting[lang][13]}</b></h3>
    </div>
</div>
        </div>
        )
}